// Library Imports
import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import * as moment from "moment";
import loadable from '@loadable/component';
import LoadingFallBack from "../loadingFallBack";
import FileBase64 from "react-file-base64";
import ReactPlayer from "react-player";
// Service Imports
import { ProductService } from "../../services/product.service";
import { LoginService } from "../../services/login.service";
import { StudentAssessmentService } from "../../services/studentAssessment.service";
// Other Imports
import CustomSelect, { createOptions1 } from '../userprofile/CustomSelect';
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import {
  success,
  warning,
  successNotification,
  error,
  errorNotification,
  warningNotification,
} from "../notification/notifications";
// Component Imports
const OpsEditQuestion = loadable(() => import('./opsEditQuestion'), {
  fallback: <LoadingFallBack/>
});
// Unused Imports
// import { addAdminUser } from "../../services/admin.service";
// import { RegionManagementService } from "../../services/regionManagement.service";
// import { RegisterUserService } from "../../services/registration.service";
// import RestDataSource from "../../services/restdatasource";
// import { Global_var } from "../../global/global_var";
// import { fetchProductTypeData } from "../../services/fetchStudentDashboard.service";
// import OpsEditQuestion from "./opsEditQuestion";



class EditProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: "",
      productName: this.props.history.location.state.product.productName
        ? this.props.history.location.state.product.productName
        : "",
      productThumbnail: this.props.history.location.state.product
        .productThumbnail
        ? this.props.history.location.state.product.productThumbnail
        : localStorage.getItem("prdthumbnail")
        ? localStorage.getItem("prdthumbnail")
        : "",
      productLink: this.props.history.location.state.product.productLink
        ? this.props.history.location.state.product.productLink
        : "",
      partnerPartyID: this.props.history.location.state.product.partnerID
        ? this.props.history.location.state.product.partnerID
        : "",
      partner: "",

      isParentProduct: this.props.history.location.state.product.isParentProduct
        ? this.props.history.location.state.product.isParentProduct
        : "",
      parentProductID: this.props.history.location.state.product.parentProductID
        ? this.props.history.location.state.product.parentProductID
        : "",

      buid: this.props.history.location.state.product.buid
        ? this.props.history.location.state.product.buid
        : "",
      productAnchor: this.props.history.location.state.product.productAnchor
        ? this.props.history.location.state.product.productAnchor
        : "",
      productSubtitle: this.props.history.location.state.product.productSubtitle
        ? this.props.history.location.state.product.productSubtitle
        : "",
      productLanguage: this.props.history.location.state.product.productLanguage
        ? this.props.history.location.state.product.productLanguage
        : "",

      productDescription: this.props.history.location.state.product
        .productDescription
        ? this.props.history.location.state.product.productDescription
        : "",
      productTypeList: this.props.productType ? this.props.productType : "",
      partnerList: [],
      productType: this.props.history.location.state.product.productType
        ? this.props.history.location.state.product.productType
        : "",
      productCode: this.props.history.location.state.product.productCode
        ? this.props.history.location.state.product.productCode
        : "",
      productPrice: this.props.history.location.state.product.productPrice
        ? this.props.history.location.state.product.productPrice
        : "",
      // productSequence: this.props.history.location.state.product
      //   .productDisplaySequence
      //   ? this.props.history.location.state.product.productDisplaySequence
      //   : "",
      isActive: this.props.history.location.state.product.isActive
        ? this.props.history.location.state.product.isActive
        : "",
      createdBy: this.props.history.location.state.product.createdBy
        ? this.props.history.location.state.product.createdBy
        : "",
      createdDate: this.props.history.location.state.product.createdDate
        ? this.props.history.location.state.product.createdDate
        : "",
      lastModifiedBy: this.props.history.location.state.product.lastModifiedBy
        ? this.props.history.location.state.product.lastModifiedBy
        : "",
      lastModifiedDate: this.props.history.location.state.product
        .lastModifiedDate
        ? this.props.history.location.state.product.lastModifiedDate
        : "",
      productMinPassingScore: this.props.history.location.state.product
        .productMinPassingScore === 0 ? 0
        : this.props.history.location.state.product.productMinPassingScore
        ? this.props.history.location.state.product.productMinPassingScore
        : "",
      totalScore: this.props.history.location.state.product.totalScore === 0 ? 0
        : this.props.history.location.state.product.totalScore
        ? this.props.history.location.state.product.totalScore
        : "",
      partnerID: this.props.history.location.state.product.partnerID
        ? this.props.history.location.state.product.partnerID
        : "",
      productID: this.props.history.location.state.product.productID
        ? this.props.history.location.state.product.productID
        : "",
      providerProductID: this.props.history.location.state.product
        .providerProductID
        ? this.props.history.location.state.product.providerProductID
        : "",
      productVideourl: this.props.history.location.state.product.productVideourl
        ? this.props.history.location.state.product.productVideourl
        : localStorage.getItem("prdvideourl")
        ? localStorage.getItem("prdvideourl")
        : "",
      role: "",
      status: "",
      statusList: this.props.status ? this.props.status : "",

      hasModules: this.props.history.location.state.product.hasModules
        ? this.props.history.location.state.product.hasModules
        : "",
      isDisplayinCourseCatalog: this.props.history.location.state.product
        .isDisplayinCourseCatalog
        ? this.props.history.location.state.product.isDisplayinCourseCatalog
        : "",
      productVidoeDocId:
        this.props.history.location.state.product.productVidoeDocId,
      productThumbnailDocId:
        this.props.history.location.state.product.productThumbnailDocId,

      loading: false,
      autoplay: false,
      listOfHours: [],
      listOfMins: [],
      listOfSecs: [],
      allCategories: [],
      allSubCategories: [],
      filteredCategory: [],
      fetchProductDetail: {},
      iamLookingFor:[],
      productLevel:[],
      durationDaysValidate1: false,
      durationDaysValidate2: false,
      TypeOfCourseList:[],
      courseTypeID:"",
      strikethroughPrice:"",
      submitBtnClick:false,
      isEdit: false,
      questionnaireData: [],
      document: [],
      documentTypeCheckForProductTImage: false,
      documentSizeCheckForProductCheck: false,
      documentTypeCheckForDescriptionFile: false,
      documentSizeCheckForDescriptionFile: false,
      documentTypeCheckForBrochure: false,
      documentSizeCheckForBrochure: false,
      documentSizeCheckForAdmission:false,
      documentTypeCheckForAdmission:false,
      isShow:false,
      addOnCourseList:[],
      selectedAddOnCourses:[],
      isConfirmedParent:false,
      isConfirmedPrice:false,
      isConfirmedStatus:false
    };
    //console.log('editproduct state data : ', this.state);
  }

  initailizedTimeDetails = () => {
    var listOfHours = [];
    var listOfMins = [];
    var listOfSecs = [];

    for (var i = 0; i < 2161; i++) {
      listOfHours.push(i);
    }
    for (var j = 0; j < 60; j++) {
      listOfMins.push(j);
      listOfSecs.push(j);
    }

    this.setState({ listOfHours: listOfHours });
    this.setState({ listOfMins: listOfMins });
    this.setState({ listOfSecs: listOfSecs });
  };
  GetAllCategoryByLevel = (level, data, fn) => {
    LoginService.TokenUser((res) => {
      if (res.status === "success") {
        ProductService.fetchAllCategoryByLevel(
          `level=${level}`,
          data,
          (res1) => {
            console.log("res", res1);

            fn(res1.responseListObject);
            this.setState({ loading: false });
          }
        );
      } else if (res.status === "fail") {
        this.setState({ loading: false });
        if (res.reasonCode === "SM_11") {
          window.location.href = "/";
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
          error(res.reasonText, errorNotification);
        }
      }
    });
  };

  selectCategory(value, setFieldValue) {
    const data = {
      filteredCategory: [value],
    };

    if (value) {
      ProductService.fetchAllCategoryByLevel(`level=1`, data, (res1) => {
        setFieldValue("allSubCategories", res1.responseListObject);
        setFieldValue("subCategory", "");
      });
    } else {
      setFieldValue("allSubCategories", []);
      setFieldValue("subCategory", "");
    }
  }

  componentWillMount() {
    LoginService.TokenUser((res) => {
      localStorage.setItem("jwt-token", res.responseObject);
    });
  }

  componentDidMount() {
    this.setState({ isEdit: true });
    if([2,"2"].includes(this.props.location?.state?.product?.courseTypeID)){
    let productID = this.props.location?.state?.product?.productID;
    let params = `jobid=0&productID=${productID}`;
    let questionnaireDataProp = [];
    let newTotalScore = 0;
    StudentAssessmentService.getQuestionnaire(params, (res) => {
      console.log("question data", res);
      if ((res.status = "success" && res.reasonText === null)) {
        questionnaireDataProp = res.responseListObject;
        let ads = res.responseListObject.map((item) => {
          newTotalScore += parseInt(item.score);
        });
        console.log("ads", ads);
        console.log("newTotalScore", newTotalScore);
        this.setState({
          questionnaireData: questionnaireDataProp,
          totalScore: newTotalScore,
        },()=>{
          this.state.questionnaireData.length > 0 ? this.setState({ isShow: true }) : this.setState({ isShow: false });
        });
      }
    });
    }
    ProductService.getTypeOfCourseList((res) => {
      this.setState({loading1:true})
      if(res.status==="success"){
      this.setState({
        TypeOfCourseList: res.responseListObject,
        loading1:false
      });
    }
    });
    localStorage.getItem("productTypeedit")
      ? this.setState({
          productTypeList: JSON.parse(localStorage.getItem("productTypeedit")),
        })
      : this.setState({
          productTypeList: this.props.productType,
        });

    localStorage.getItem("statusedit")
      ? this.setState({
          statusList: JSON.parse(localStorage.getItem("statusedit")),
        })
      : this.setState({
          statusList: this.props.status,
        });

    this.setState({});

    this.fetchProductDetailByID();
    this.handleSelectedAddonCourses(this.state.productID);
    setTimeout(()=>{
      this.handleDataFetchAddonCourses(this.state.fetchProductDetail?.courseTypeID,this.state.productID);
    },2500)
    
    this.initailizedTimeDetails();
    this.GetAllCategoryByLevel(0, {}, (items) =>
      this.setState({
        allCategories: items ? items : [],
      })
    );
    //console.log("Props data ", this.props.fetchProductTypeData);
    ProductService.productIamLookingFor(res =>{
      this.setState({
        iamLookingFor: res.data.responseListObject,
      });      
    });
    ProductService.productLevel(res =>{
      this.setState({
        productLevel: res.data.responseListObject,
      });
    });
  }

  handleUpload = (ev) => {};
  handleCancel = () => {
    this.props.history.goBack("-1");
  };

  fetchProductDetailByID=()=>{
    let productID = this.props.location.state.product.productID;
    // console.log("Product ID", productID);
    let params = "productID=" + productID;

    ProductService.getProductDetailById(params, (res) => {
      console.log("productName", res.responseObject);
      if (res.status === "success") {
        let durationString = res.responseObject.duration;
        this.setState({productMinPassingScore:res?.responseObject?.productMinPassingScore})

        if(res.responseObject.durationType === "hours"){
        let duration = `${parseInt(durationString.split(":")[0])}:${parseInt(
          durationString.split(":")[1]
        )}:${parseInt(durationString.split(":")[2])}`;
        res.responseObject.duration = duration;
        let durationString1 = res.responseObject.duration;
        let duration1 = durationString1.split(":");
        this.setState({
          loading: false,
          fetchProductDetail: {
            ...res.responseObject,
            hours: duration1[0],
            minutes: duration1[1],
            seconds: duration1[2],
            durationDays:""
          },
        });
        }else if(res.responseObject.durationType === "days"){
          let duration = durationString.split(" ");
          this.setState({
            loading: false,
            fetchProductDetail: {
              ...res.responseObject,
              hours: "",
              minutes: "",
              seconds: "",
              durationDays:duration[0]
            },
          });
        }
        var data = {
          filteredCategory: [res.responseObject.categoryID],
        };
        console.log("data", data);

        this.GetAllCategoryByLevel(1, data, (items) => {
          console.log(
            "Vishal",
            items,
            res.responseObject,
            items.filter(
              (item) =>
                item.parCategory === res.responseObject.subCategoryID ||
                item.parCategory === res.responseObject.categoryID
            )
          );
          this.setState({
            allSubCategories: items ? items : [],
            filteredCategory: items
              ? items.filter(
                  (item) => item.parCategory === res.responseObject.categoryID
                )
              : [],
          });
        });
      } else {
        this.setState({
          loading: false,
          fetchProductDetail: {
            ...res.responseObject,
            hours: "",
            minutes: "",
            seconds: "",
            durationDays:""
          },
        });
      }
    });
  }
  handleNumberChange1 = (e,setFieldValue) => {
    e.preventDefault();
    let input = e.target.value.replace(/[^\d.]/g, ''); // Remove non-digit characters
    const parts = input.split('.');
    if (parts.length > 2) {
      // If there are more than two parts (more than one dot), keep only the first part
      input = parts[0] + '.' + parts.slice(1).join('');
    } else if (parts.length === 2) {
      // If there's a dot, ensure only two digits follow it
      parts[1] = parts[1].slice(0, 2);
      input = parts.join('.');
    }
    setFieldValue("strikethroughPrice",input.slice(0, 10))
    console.log("input",input,parseInt(input),parseFloat(input));
    if(parseInt(input) < 1){
      this.setState({strikeValidationMsg:true})
    }else{
      this.setState({strikeValidationMsg:false})
    }
  }
  // handleNumberChange = (e, setFieldValue) => {
  //   e.preventDefault();
  //   const input = e.target.value;
  //   const cleanedInput = input.replace(/\D/g, ''); // Remove non-digit characters
  //   if (cleanedInput.charAt(0) === '0') {
  //     setFieldValue("durationDays", cleanedInput.slice(1, 3)); // If the first character is '0', replace it with an empty string
  //   } else if (cleanedInput.charAt(0) === '9') {
  //   setFieldValue("durationDays", cleanedInput.charAt(0) + (cleanedInput.charAt(1) === '0' ? '0' : '')); // If the first character is '9', allow only '0' as the second character
  //   } else {
  //     setFieldValue("durationDays", cleanedInput.slice(0, 2)); // For other cases, limit the input to two characters
  //   }
  // }
  handleNumberChange = (e,setFieldValue,value) => {
    e.preventDefault();
    const input = e.target.value.replace(/\D/g, '');
    if(["durationDays"].includes(value)){
      setFieldValue("durationDays",input.slice(0, 2))
    }else if(["productMinPassingScore"].includes(value)){
      setFieldValue("productMinPassingScore",input.slice(0, 10))
    }else if(["totalScore"].includes(value)){
      setFieldValue("totalScore",input.slice(0, 10))
    }
  }
  scrollToSection = (sectionId) => {
    const section =document.getElementById(sectionId);    
    if (section ){
        section.scrollIntoView({ behavior: 'auto',block: "end",inline:"center" });
    }
  }
  handleCallback = (childData, totalScore) => {
    this.setState({ questionnaireData: childData });
    this.setState({ totalScore: totalScore ? totalScore : 0});
    childData.length > 0 ? this.setState({ isShow: true }) : this.setState({ isShow: false })
  };
  handleSelectedAddonCourses=(parentProductID)=>{
    let parentProductID1=parentProductID?parentProductID:"";
    let params2=`parProductId=${parentProductID1}`
    ProductService.getSelectedAddOnCourseList(params2,(res) => {
      this.setState({loading2:true})
      if(res.status==="success"){
        console.log("addonselected",res.responseListObject)
        let selectedAddOnCourses1=[];
         res.responseListObject.map((item) => {
          if([1,"1"].includes(item.isActive)){
            selectedAddOnCourses1.push(item.childProdId)
            }
      });      
      this.setState({
        selectedAddOnCourses:selectedAddOnCourses1,
        loading2:false
      });
    }
    else{
      this.setState({
        selectedAddOnCourses:[],
        loading2:false
      });
    }
    });
  }
  handleCheckParentChildExists=()=>{
    let params2=`prodId=${this.state.productID}`;
    ProductService.checkIfChildOrParentExists(params2,(res) => {
      this.setState({loading2:true})
      if((["Add-on course found","Parent course found","Add-on course and Parent course found"].includes(res.reasonText))){
        this.setState({
          Type:"Status",
          TypeText:res.reasonText
        },()=>{
  
          window.$('#myConfirmModalStatus').modal({ backdrop: 'static', keyboard: false }, 'show')
        })
      this.setState({
        loading2:false
      });
    }
    else{
      this.setState({
          loading2:false,
          isConfirmedStatus:true
        });
        setTimeout(()=>{
          if(this.state.isConfirmedPrice&&this.state.isConfirmedParent&&this.state.isConfirmedStatus){
          var SubmitBtn = document.getElementById("UpdateCourseSubmit");
          if (SubmitBtn) {
              SubmitBtn.click();
          } else {
              console.error("Element not found");
          }
        }
        },1500) 
        
    }
    });
  }
  handleParentMaxPrice=(values)=>{
    let params1=`prodId=${this.state.productID}`
  ProductService.getParentMaxPrice(params1,(res) => {
  this.setState({loading2:true})
if((res.MaxPrice<values.productPrice)&&(res.MaxPrice !== -1)){
  this.setState({
    Type:"Parent"
  },()=>{
    window.$('#myConfirmModalParent').modal({ backdrop: 'static', keyboard: false }, 'show')
  })
  }
  else{
    this.setState({
      isConfirmedParent:true
    })
    setTimeout(()=>{
      if(this.state.isConfirmedPrice&&this.state.isConfirmedParent&&this.state.isConfirmedStatus){
      var SubmitBtn = document.getElementById("UpdateCourseSubmit");
      if (SubmitBtn) {
          SubmitBtn.click();
      } else {
          console.error("Element not found");
      }
    }
    },1500) 
  }
      this.setState({
        loading2:false
      });
    });
  }
  handleDataFetchAddonCourses=(courseTypeID,parentProductID)=>{
    let courseTypeID1=courseTypeID?courseTypeID:"";
    let parentProductID1=parentProductID?parentProductID:"";
    let params1=`courseTypeId=${courseTypeID1}&parProductId=${parentProductID1}`
    ProductService.getAddOnCourseList(params1,(res) => {
      this.setState({loading2:true})
      if(res.status==="success"){
      this.setState({
        addOnCourseList: res.responseListObject,
        loading2:false
      });
    }
    else{
      this.setState({
        addOnCourseList:[],
          loading2:false
        });
    }
    });
  }
  handleConfirmationPopUp=async (values)=>{
    let selectedAddOnCoursesList=await this.state.addOnCourseList.filter((item)=>(
      values.selectedAddOnCourses.includes(item.productid)
      ))
      let isFoundChild;
      if(values.topFree==="Y"||values.isFree==="Y"){
        isFoundChild=await selectedAddOnCoursesList.some((item)=>(
          0<parseInt(item.productPrice)
        ))
    }
    if(values.productPrice){
      isFoundChild=await selectedAddOnCoursesList.some((item)=>(
        parseInt(values.productPrice)<parseInt(item.productPrice)
        ))
    }
    this.handleParentMaxPrice(values);
    if(["0",0].includes(values.isActive)){
      this.handleCheckParentChildExists()
    }
    else{
      this.setState({
        isConfirmedStatus:true
      });
      setTimeout(()=>{
        if(this.state.isConfirmedPrice&&this.state.isConfirmedParent&&this.state.isConfirmedStatus){
        var SubmitBtn = document.getElementById("UpdateCourseSubmit");
        if (SubmitBtn) {
            SubmitBtn.click();
        } else {
            console.error("Element not found");
        }
      }
      },1500) 
    }
    if(isFoundChild){
      this.setState({
        Type:"Price"
      },()=>{
        window.$('#myConfirmModalPrice').modal({ backdrop: 'static', keyboard: false }, 'show')
      })
    }
  else{
    this.setState({
      isConfirmedPrice:true
    })
    setTimeout(()=>{
      if(this.state.isConfirmedPrice&&this.state.isConfirmedParent&&this.state.isConfirmedStatus){
      var SubmitBtn = document.getElementById("UpdateCourseSubmit");
      if (SubmitBtn) {
          SubmitBtn.click();
      } else {
          console.error("Element not found");
      }
    }
    },1500) 
  }
  
  }
  removeStateYes = (value) => {
    $(".modal-backdrop").hide();
    if(value==="price"){
      this.setState({
        isConfirmedPrice:true
      })
    }
    else if(value==="status"){
      this.setState({
        isConfirmedStatus:true
      })
    }
    else if(value==="parent"){
      this.setState({
        isConfirmedParent:true
      })
    }
  setTimeout(()=>{
    if(this.state.isConfirmedPrice&&this.state.isConfirmedParent&&this.state.isConfirmedStatus){
    var SubmitBtn = document.getElementById("UpdateCourseSubmit");
    if (SubmitBtn) {
        SubmitBtn.click();
    } else {
        console.error("Element not found");
    }
  }
  },1500) 
  }
  removeStateNo = (value) => {
    $(".modal-backdrop").hide();
    const section = document.getElementById("selectedAddOnCourses");  
    if (section) {
      section.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
      section.focus();
    }
    if(value==="price"){
      this.setState({
        isConfirmedPrice:false
      })
    }
    else if(value==="status"){
      this.setState({
        isConfirmedStatus:false
      })
    }
    else if(value==="parent"){
      this.setState({
        isConfirmedParent:false
      })
    }
  }
  
  render() {
    console.log("props", this.props);
    console.log("state", this.state);

    const { fetchProductDetail } = this.state;
    // const urls =
      // /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)+$/;

    return (
      <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          today: moment(new Date()).format("YYYY-MM-DD"),
          products: "",
          productType: this.state.productType.toString(),
          productName: this.state.productName,
          // productThumbnail: this.state.productThumbnail,
          productThumbnail: fetchProductDetail.productThumbnail,
          productLink: this.state.productLink,
          productAnchor: this.state.productAnchor,
          productSubtitle: this.state.productSubtitle,
          productLanguage: this.state.productLanguage,
          productDescription: this.state.productDescription,

          productCode: this.state.productCode,
          // productPrice: parseInt(this.state.productPrice),
          productPrice: this.state.productPrice,
          // productVideourl: this.state.productVideourl,
          productVideourl: fetchProductDetail.productVideourl,

          partnerPartyID: this.state.partnerPartyID,
          partner: this.state.partnerID,
          isParentProduct: this.state.isParentProduct,
          parentProductID: this.state.parentProductID,
          // productSequence: parseInt(this.state.productSequence),
          statusList: this.props.status,

          createdBy: this.state.createdBy,
          createdDate: this.state.createdDate,
          lastModifiedBy: this.state.lastModifiedBy,
          lastModifiedDate: "",

          productMinPassingScore: this.state.productMinPassingScore === 0 ? 0 : this.state.productMinPassingScore?this.state.productMinPassingScore:"",
          totalScore: this.state.totalScore === 0 ? 0 : this.state.totalScore?this.state.totalScore:"",
          partnerID: this.state.partnerID,

          providerProductID: this.state.providerProductID,

          role: "",
          isActive: Number(this.state.isActive),

          hasModules: this.state.hasModules,
          isDisplayinCourseCatalog: this.state.isDisplayinCourseCatalog,
          document: this.state.document ? this.state.document : [],

          category: fetchProductDetail.categoryID,
          isFree: fetchProductDetail.isFree,
          gcubeId: fetchProductDetail.gcubeID ? fetchProductDetail.gcubeID : "",
          hours: fetchProductDetail.hours,
          minutes: fetchProductDetail.minutes,
          seconds: fetchProductDetail.seconds,
          subCategory: fetchProductDetail.subCategoryID,
          allSubCategories: [],
          listOfHours: this.state.listOfHours,
          listOfMins: this.state.listOfMins,
          listOfSecs: this.state.listOfSecs,
          topFree:fetchProductDetail.topFree,
          lookingFor:fetchProductDetail.lookForID || "",
          descriptionFile:fetchProductDetail.descFile || "",
          level:fetchProductDetail.levelID || "",
          mostPopular:fetchProductDetail.isMostPopular,
          documentTypeCheckForProductTImage: this.state.documentTypeCheckForProductTImage ? this.state.documentTypeCheckForProductTImage : false,
          documentSizeCheckForProductCheck: this.state.documentSizeCheckForProductCheck ? this.state.documentSizeCheckForProductCheck : false,
          documentTypeCheckForDescriptionFile: this.state.documentTypeCheckForDescriptionFile ? this.state.documentTypeCheckForDescriptionFile : false,
          documentSizeCheckForDescriptionFile: this.state.documentSizeCheckForDescriptionFile ? this.state.documentSizeCheckForDescriptionFile : false,
          documentTypeCheckForBrochure: this.state.documentTypeCheckForBrochure ? this.state.documentTypeCheckForBrochure : false,
          documentSizeCheckForBrochure: this.state.documentSizeCheckForBrochure ? this.state.documentSizeCheckForBrochure : false,
          documentTypeCheckForAdmission: this.state.documentTypeCheckForAdmission ? this.state.documentTypeCheckForAdmission : false,
          documentSizeCheckForAdmission: this.state.documentSizeCheckForAdmission ? this.state.documentSizeCheckForAdmission : false,
          durationDH:fetchProductDetail.durationType,
          durationDays:fetchProductDetail.durationDays,
          brochurePdf:fetchProductDetail.brochureFile,
          admissionPdf:fetchProductDetail.admissionLetterDocURL,
          courseTypeID:fetchProductDetail.courseTypeID?fetchProductDetail.courseTypeID:"",
          TypeOfCourseList:this.state.TypeOfCourseList,
          strikethroughPrice:fetchProductDetail.strikethroughPrice?fetchProductDetail.strikethroughPrice:"",
          questionnaireData: this.state.questionnaireData ? this.state.questionnaireData : [],  
          isShow: this.state.isShow,   
          selectedAddOnCourses:this.state.selectedAddOnCourses?this.state.selectedAddOnCourses:[],
          addOnCourseList:this.state.addOnCourseList?this.state.addOnCourseList:[],
        }}
      
        validationSchema={Yup.object().shape({
          //static validations
          productType: Yup.string().required("You must specify a Product Type"),
          isActive: Yup.string().required("You must specify a Product status"),
          courseTypeID:Yup.string().when("productType",{
            is: productType => productType === "10502" ? true : false,
            then: Yup.string().required("You must specify a Type Of Course"),
            otherwise: Yup.string(),
          }),
          productName: Yup.string().required(
            " You must specify a Product Name"
            ),
            // productCode: Yup.string(),
            // productLink: Yup.string().matches(urls, {
            //   message: "Enter valid url",
            //   excludeEmptyString: false,
            // }),
            partner: Yup.string().required("You must specify a Partner"),
            // productAnchor: Yup.string(),
            // productSubtitle: Yup.string(),
            // productLanguage: Yup.string(),
            // productPrice: Yup.string()
            //   .matches(
              //     /^[0-9]+\d$/,
              //     "Please provide valid product price more than one number and 2 decimals values only"
              //   )
              //   .required("You must specify a product price"),
              //productThumbnail: Yup.string().required("You must specify a Product Thumbnail"),
              // productLink: Yup.string().matches("(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})" , 'invalid url'),
              
              //productVideourl: Yup.string().required("You must specify a VideoURL"),
                // productSequence: Yup.string()
                //   .required("You must specify a Sequence Number")
                //   // .matches(/^[0-9]{1,2}$/, "Only Numbers are allowed, 1 to 99"),
                //   .matches(/^(?!0$)(?!00$)\d{1,2}$/,"Only Numbers are allowed, 1 to 99"),
              gcubeId: Yup.string().when("productType", {
                is: (productType) => (productType === "10502" ? true : false),
                then: Yup.string()
                  .required("You must specify a G Cube ID")
                  .max(10, "G Cube ID should not be greater then 10 characters")
                  .matches(/^([0-9]\d*)?$/, "Please provide valid Gcube ID"),
                otherwise: Yup.string(),
              }),
                
             isFree: Yup.string().when("productType", {
                  is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().required("You must specify Is Free"),
            otherwise: Yup.string(),
          }),
          productPrice: Yup.string().when("isFree", {
            is: (isFree) => (isFree === "N" ? true : false),
            then: Yup.string()
              .required("Price is required")
              .max(10, "Price Should not be greater than 10 Numbers")
              .matches(
                // /^([1-9]\d*|0{1})([1-9]\d*|0)(\.\d{0,2})?$/,
                // "Please provide valid price Value more than one number and 2 decimals values only"
                /^([1-9]{1})(\d*)(\.\d{0,2})?$/,
                "Please provide valid price Value and 2 decimals values only"
              ),
            otherwise: Yup.string().when("productType", {
              is: (productType) => (productType !== "10502" ? true : false),
              then: Yup.string()
                .required("Price is required")
                .max(10, "Price Should not be greater than 10 Numbers")
                .matches(
                  // /^([1-9]\d*|0{1})([1-9]\d*|0)(\.\d{0,2})?$/,
                  // "Please provide valid price Value more than one number and 2 decimals values only"
                  /^([1-9]{1})(\d*)(\.\d{0,2})?$/,
                  "Please provide valid price Value and 2 decimals values only"
                ),
              otherwise: Yup.string(),
            }),
          }),
          strikethroughPrice: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().when("isFree", {
              is: (isFree) => (isFree === "N" ? true : false),
              then: Yup.string().when("courseTypeID", {
                is: (courseTypeID) => (courseTypeID === "2" ? true : false),
                then: Yup.string()
                // .required("You must specify Strikethrough Price")
                .max(10, "Strikethrough Price Value not greater than 10")
                .matches(
                  // /^([1-9]\d*|0)(\.\d{0,2})?$/,
                  /^([1-9]{1})(\d*)(\.\d{0,2})?$/,
                  "Please provide valid Strikethrough Price Value and 2 decimals values only"
                  ),
                  otherwise: Yup.string(),
            }),
            otherwise: Yup.string(),
          }),
          otherwise: Yup.string(),
        }),
          durationDH:Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().required("You must specify a Duration in days/hours"),
            otherwise: Yup.string(),
          }),
          hours: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().when("durationDH",{
              is: (durationDH) => (durationDH === "hours" ? true : false),
              then: Yup.string().required("You must specify a hours"),
              otherwise: Yup.string(),
            }),
            otherwise: Yup.string(),
          }),
          minutes: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().when("durationDH",{
              is: (durationDH) => (durationDH === "hours" ? true : false),
              then: Yup.string().required("You must specify a minutes"),
              otherwise: Yup.string(),
            }),
            otherwise: Yup.string(),
          }),
          seconds: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().when("durationDH",{
              is: (durationDH) => (durationDH === "hours" ? true : false),
              then: Yup.string().required("You must specify a seconds"),
              otherwise: Yup.string(),
            }),
            otherwise: Yup.string(),
          }),
          durationDays: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().when("durationDH",{
              is: (durationDH) => (durationDH === "days" ? true : false),
              then: Yup.string().required("You must specify a Duration in Days"),
              // .matches(/^(?:[1-9]|[1-8][0-9]|90)$/,"You cannot add less than 0 and more than 90 days"),
              otherwise: Yup.string(),
            }),
            otherwise: Yup.string(),
          }),
          category: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().required("You must specify a Category"),
            otherwise: Yup.string(),
          }),
          lookingFor: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().required("You must specify a Looking For"),
            otherwise: Yup.string(),
          }),
          productMinPassingScore: Yup.string().when("isShow",{
            is: (isShow) => (isShow === true ? true : false),
            // then: Yup.string().required("You must specify Minimum Passing Score").matches(/^[0-9]+\d$/,"Please provide valid minimum passing score"),
            then: Yup.string().required("You must specify Minimum Passing Score").matches(/^[0-9]*$/,"Please provide valid minimum passing score"),
            otherwise: Yup.string(),
          }),
          totalScore: Yup.string().when("isShow",{
            is: (isShow) => (isShow === true ? true : false),
            // then: Yup.string().required("You must specify Total Score").matches(/^[0-9]+\d$/,"Please provide valid score"),
            then: Yup.string().required("You must specify Total Score").matches(/^[0-9]*$/,"Please provide valid score"),
            otherwise: Yup.string(),
          }),
          level: Yup.string().when("productType", {
            is: (productType) => (productType === "10502" ? true : false),
            then: Yup.string().required("You must specify a Level"),
            otherwise: Yup.string(),
          }),   
        })}
        onSubmit={(values) => {
          if(!this.state.isConfirmedParent||!this.state.isConfirmedPrice||!this.state.isConfirmedStatus){
            this.handleConfirmationPopUp(values);
            }
          if(this.state.isConfirmedParent&&this.state.isConfirmedPrice&&this.state.isConfirmedStatus){
          if(values.durationDH === "days"){
          if(parseInt(values.durationDays) < 1){
            warning("You can not add less than 1 day",warningNotification);
            return;
          }
          if(parseInt(values.durationDays) > 90){
            warning("You can not add more than 90 days",warningNotification);
            return;
          }
          }
          if(values.durationDH === "hours"){
          if(parseInt(values.hours) === 2160){
            if(parseInt(values.minutes) > 0 || parseInt(values.seconds) > 0){
              warning("You can not add more than 2160 hours",warningNotification);
              return;
            }
          }
          }
          if(values.isShow === true){
            if (["", null, undefined].includes(values.productMinPassingScore)) {
              warning("Please Enter Minimum Passing Score", warningNotification);
              return;
            }
            if (["", null, undefined].includes(values.totalScore)) {
              warning("Please Enter Total Score", warningNotification);
              return;
            }
            if (values.productMinPassingScore > values.totalScore) {
              warning(
                "Minimum Passing Score should not be greater than Total Score",
                warningNotification
              );
              return;
            }
          }
          let formattedTime = "";

          if (
            (values["seconds"] !== undefined && values["seconds"] !== "") ||
            (values["minutes"] !== undefined && values["minutes"] !== "") ||
            (values["hours"] !== undefined && values["hours"] !== "")
          ) {
            let hours =
              values["hours"].length === 1
                ? "0" + values["hours"]
                : values["hours"];
            let minutes =
              values["minutes"].length === 1
                ? "0" + values["minutes"]
                : values["minutes"];
            let seconds =
              values["seconds"].length === 1
                ? "0" + values["seconds"]
                : values["seconds"];
            formattedTime = hours + ":" + minutes + ":" + seconds;
          } else {
            formattedTime = "";
          }
          if(values.durationDH === "hours"){
          if (
            ([0,"0"].includes(values["seconds"])) &&
            ([0,"0"].includes(values["minutes"])) &&
            ([0,"0"].includes(values["hours"]))
          ) {

            warning("please provide valid duration",warningNotification);
            this.scrollToSection("durationinhours")
            return;

          }
          }
          if(values["documentSizeCheckForBrochure"]===true||values["documentTypeCheckForBrochure"]===true){
            this.scrollToSection("brochurePDF")
            return;
          }
          if([2,"2"].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor)){
            if(values["documentSizeCheckForBrochure"]===true||values["documentTypeCheckForBrochure"]===true){
              this.scrollToSection("admissionPdf")
              return;
            }
          }
          this.setState({submitBtnClick:true})

          // var productSequence =
          //   "sequenceNumber=" + parseInt(values.productSequence);
          // ProductService.checkSequenceDuplication(productSequence, (sd) => {
          //   this.setState({ loading: true });
          //   var isSequenceDuplicate = true;
          //   // if (sd.totalRecords === 0) {
          //   if (["0", 0].includes(sd.totalRecords)) {
          //     isSequenceDuplicate = false;
          //   } else if (sd.totalRecords > 0) {
          //     if (
          //       this.state.productID ===
          //       sd.responseListObject.find((x) => x).productID
          //     ) {
          //       isSequenceDuplicate = false;
          //     }
          //   }

          //   if (!isSequenceDuplicate) {
              if (values.document.length >= 1) {
                values.document.forEach((element) => {
                  let data1 = {
                    documentType: element.documentType,
                    documentKey: localStorage.getItem("userid-Token"),
                    documentName: element.documentName,
                    replaceIfExists: "1",
                    documentHash: element.documentHash,
                    storageLocation: "AWS",
                    partyId: localStorage.getItem("userid-Token"),
                    buId: "2",
                    bucketTag: "finx-bucket-tag",
                    documentTag: element.documentType,
                  };
                  ProductService.addProductImageVideo(
                    data1,
                   (cb) => {
                      if (
                        cb.responseObject.documentType === "ProductThumbNail"
                      ) {
                   localStorage.setItem(
                          "prdthumbnail",
                          cb.responseObject.documentId
                        );
                        localStorage.setItem(
                          "productThumbnail",
                          cb.responseObject.documentPath
                        );
                      }
                      if(cb.responseObject.documentType === "ProductDescription"){
                        localStorage.setItem("descFile",cb.responseObject.documentPath);
                      }
                      if(cb.responseObject.documentType === "ProductBrochure"){
                        localStorage.setItem("brochurePdf",cb.responseObject.documentPath);
                      }
                      if(cb.responseObject.documentType === "ProductAdmissionLetter"){
                        localStorage.setItem("admissionPdf",cb.responseObject.documentPath);
                        localStorage.setItem("admissionPdfID",cb.responseObject.documentId)
                      }
                      // if (
                      //   cb.responseObject.documentType === "ProductVideourl"
                      // ) {
                      //  localStorage.setItem(
                      //     "prdvideourl",
                      //     cb.responseObject.documentId
                      //   );
                      //   localStorage.setItem("productVideourl",cb.responseObject.documentPath);
                      // }

                      //console.log("CB", cb.status);
                      if (cb.status === "success") {
                        setTimeout(() => {
                          // let hasModule = "";
                          // if (values.hasModules === true) {
                          //   hasModule = 1;
                          // } else {
                          //   hasModule = 0;
                          // }

                          // let isDisplayinCourseCatalog = "";
                          // if (values.isDisplayinCourseCatalog === true) {
                          //   isDisplayinCourseCatalog = 1;
                          // } else {
                          //   isDisplayinCourseCatalog = 0;
                          // }
                          let data11=values.selectedAddOnCourses?values.selectedAddOnCourses:[];
                          let params11=`parentProdId=${this.state.productID}`;
                          this.setState({loading1:true})
                          ProductService.updateAddOnCourse(
                            params11,data11,
                           (cb) => {
                            if (cb.status === "success") {
                              console.log("add on API",cb)
                              this.setState({
                                loading1:false
                              })
                            }else{
                              this.setState({
                                loading1:false
                              })
                            }
                          });
                          let today = new Date();
                          let data = {
                            productID: this.state.productID,
                            products: this.state.productID,
                            productName: values.productName.trim(),
                            // Please dont remove localStorage
                            // productThumbnail:localStorage.getItem("productThumbnail")
                            // ? localStorage.getItem("productThumbnail"):this.state.productThumbnail,
                            productThumbnail: localStorage.getItem("productThumbnail") 
                            ? localStorage.getItem("productThumbnail")
                            : values.productThumbnail,
                            productThumbnailDocId: localStorage.getItem(
                              "prdthumbnail"
                            )
                              ? localStorage.getItem("prdthumbnail")
                              : this.state.productThumbnailDocId,
                            // productLink: values.productLink.trim(),
                            // Please dont remove localStorage
                            // productVideourl: this.state.productVideourl,
                            // productVideourl: localStorage.getItem("productVideourl") 
                            // ? localStorage.getItem("productVideourl")
                            // : values.productVideourl,
                            // productVidoeDocId: localStorage.getItem(
                            //   "prdvideourl"
                            // )
                            //   ? localStorage.getItem("prdvideourl")
                            //   : this.state.productVidoeDocId,
                            productVideourl: values.productVideourl,
                            partnerPartyID: values.partnerPartyID,
                            partner: values.partner,
                            partnerID: values.partner,
                            isParentProduct: 1,
                            parentProductID: values.parentProductID,
                            // hasModules: hasModule,
                            hasModules: 1,
                            // isDisplayinCourseCatalog: isDisplayinCourseCatalog,
                            isDisplayinCourseCatalog: 1,
                            // buid: values.buid,
                            // productAnchor: values.productAnchor.trim(),
                            // productSubtitle: values.productSubtitle.trim(),
                            // productLanguage: values.productLanguage,
                            productDescription:
                              values.productDescription.trim(),
                            productType: values.productType,
                            // productCode: values.productCode,
                            // productPrice: values.productPrice,
                            // productDisplaySequence: parseInt(
                            //   values.productSequence
                            // ),
                            productDisplaySequence:null,
                            //isActive: values.status,
                            isActive: values.isActive,
                            createdBy: localStorage.getItem("userid-Token"),
                            createdDate: values.createdDate
                              ? moment(today).format("DD/MM/YYYY HH:mm:ss")
                              : values.createdDate,
                            lastModifiedBy: values.lastModifiedBy,
                            lastModifiedDate: values.lastModifiedDate,
                            productMinPassingScore: ([2,"2"].includes(values.courseTypeID) && values.questionnaireData.length > 0)?
                              (values.productMinPassingScore === 0 ? 0 : values.productMinPassingScore ? parseInt(values.productMinPassingScore) : "") : "",
                            totalScore: ([2,"2"].includes(values.courseTypeID) && values.questionnaireData.length > 0)?
                            (values.totalScore === 0 ? 0 : values.totalScore ? parseInt(values.totalScore) : "") : "",
                            //status: values.status,
                            productTypeList: values.productTypeList,
                            partnerList: values.partnerList,
                            statusList: values.statusList,
                            modifiedBy: localStorage.getItem("userid-Token"),

                            document: values.document,
                              //! Old
                            // categoryID:
                            //   values.subCategory &&
                            //   !Array.isArray(values.subCategory)
                            //     ? values.subCategory
                            //     : values.category,
                                // ! New
                                categoryID:
                                values.productType === "10502"
                                  ? values.category
                                    ? values.category
                                    : null
                                  : null,
                            isFree: values.topFree==="Y"?"Y":values.isFree ? values.isFree : "N",
                            productPrice:
                              values.isFree === "Y"
                                ? 0
                                // : Number(values.productPrice).toFixed(2),
                                : Math.round(values.productPrice),
                            // duration: formattedTime,
                            duration:
                            [10502,"10502"].includes(values.productType)
                                ? 
                                  values.durationDH === "hours" ? formattedTime 
                                  : values.durationDH === "days" ? `${values.durationDays} ${values.durationDH}` 
                                  : null
                                : null,
                            gcubeID:
                              values.gcubeId === 0
                                ? 0
                                : values.gcubeId
                                ? parseInt(values.gcubeId)
                                : null,
                            topFree:["1",1].includes(values.courseTypeID)?values.topFree ? values.topFree : null:null,
                            lookForID: values.lookingFor ? values.lookingFor : 0,
                            levelID: values.level ? values.level : 0,
                            isMostPopular : values.mostPopular ? values.mostPopular : null,
                            descFile:localStorage.getItem("descFile")
                            ? localStorage.getItem("descFile") 
                            : values.descriptionFile,
                            brochureFile:localStorage.getItem("brochurePdf")
                            ?localStorage.getItem("brochurePdf")
                            :values.brochurePdf,
                            durationType:values.durationDH,
                            courseTypeID:values.courseTypeID?values.courseTypeID:"",
                            strikethroughPrice:values.isFree === "Y"
                            ?""
                            :values.strikethroughPrice?Math.round(values.strikethroughPrice):"",
                            addOnProductEntityList:values.selectedAddOnCourses?values.selectedAddOnCourses:[],
                            admissionLetterDocID:(["2",2].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor))?(localStorage.getItem("admissionPdfID")?localStorage.getItem("admissionPdfID"):""):"",
                            admissionLetterDocURL:(["2",2].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor))?(localStorage.getItem("admissionPdf")?localStorage.getItem("admissionPdf"):values.admissionPdf):"",
                             };
                          console.log("DATA1",data);
                          this.setState({ loading: true });
                          ProductService.updateProduct(
                            data,
                            (cb) => {
                              //console.log("CB", cb.status);

                              if (cb.status === "success") {
                                //console.log("CB.STATUS", cb.status);
                                if([1,"1"].includes(values.courseTypeID)){
                                this.setState({ loading: false });
                                success(
                                  "Course updated successfully!",
                                  successNotification
                                );
                                // Please dont remove localStorage
                                localStorage.setItem("reload", true);
                                window.localStorage.removeItem("prdthumbnail");
                                window.localStorage.removeItem("productThumbnail");
                                window.localStorage.removeItem("prdvideourl");
                                window.localStorage.removeItem("productVideourl");
                                window.localStorage.removeItem("descFile");         
                                window.localStorage.removeItem("brochurePdf"); 
                                window.localStorage.removeItem("admissionPdf"); 
                                window.localStorage.removeItem("admissionPdfID");                         
                                this.props.history.push("/ops-course-list");
                              }else if([2,"2"].includes(values.courseTypeID)){
                                
                                let questionData = [...this.state.questionnaireData];
                                questionData.map((item, index) => {
                                  item.productID = cb.responseObject.productID;
                                });
                                if(questionData.length === 0){
                                  questionData = 
                                  [
                                    {
                                      productID: cb.responseObject.productID,
                                      optionDescEntityList: []
                                    }
                                  ]
                                }
                                window.localStorage.removeItem("prdthumbnail");
                                window.localStorage.removeItem("productThumbnail");
                                window.localStorage.removeItem("prdvideourl");
                                window.localStorage.removeItem("descFile");
                                window.localStorage.removeItem("brochurePdf");
                                window.localStorage.removeItem("admissionPdf");
                                window.localStorage.removeItem("admissionPdfID"); 
                                window.localStorage.removeItem("productVideourl");
                                StudentAssessmentService.updateQuestionnaire(
                                  questionData,
                                  (res) => {
                                    if (res.status === "success") {
                                      this.setState({ loading: false });
                                      success("Course updated successfully!", successNotification);
                                      this.props.history.push("/ops-course-list");
                                    }else{
                                      this.setState({ loading: false,submitBtnClick: false });
                                      warning(res.reasonText, warningNotification);
                                      return;
                                    }
                                  }
                                );
                              }
                              } else {
                                this.setState({ submitBtnClick:false,loading: false });
                                // error(cb.reasonText, {
                                //   ...errorNotification,
                                //   container: "top-center"
                                // });
                                // warning(cb.reasonText ? cb.reasonText : cb.status, warningNotification);
                                warning(
                                  cb.reasonText ? cb.reasonText : cb.status,
                                  {
                                    ...warningNotification,
                                    container: "top-center",
                                  }
                                );
                              }
                            },
                            (err) => console.log("Error", err)
                          );
                        }, 1000);
                      }
                      if (cb.status !== "success") {
                        // error(cb.reasonText, {
                        //   ...errorNotification,
                        //   container: "top-center"
                        // });
                        this.setState({submitBtnClick:false})
                        warning(cb.reasonText, {
                          ...warningNotification,
                          container: "top-center",
                        });
                      }
                    },
                    (err) => console.log("Error", err)
                  );
                });
              } else {
                setTimeout(() => {
                  // let hasModule = "";
                  // if (values.hasModules === true) {
                  //   hasModule = 1;
                  // } else {
                  //   hasModule = 0;
                  // }

                  // let isDisplayinCourseCatalog = "";
                  // if (values.isDisplayinCourseCatalog === true) {
                  //   isDisplayinCourseCatalog = 1;
                  // } else {
                  //   isDisplayinCourseCatalog = 0;
                  // }
                  let data11=values.selectedAddOnCourses?values.selectedAddOnCourses:[];
                  let params11=`parentProdId=${this.state.productID}`;
                  this.setState({loading1:true})
                  ProductService.updateAddOnCourse(
                    params11,data11,
                    (cb) => {
                     if (cb.status === "success") {
                      console.log("add on API",cb)
                       this.setState({
                         loading1:false
                       })
                     }else{
                       this.setState({
                         loading1:false
                       })
                     }
                   });
                  let today = new Date();
                  let data = {
                    productID: this.state.productID,
                    products: this.state.productID,
                    productName: values.productName.trim(),
                    // Please dont remove localStorage
                    // productThumbnail:localStorage.getItem("productThumbnail")
                    // ? localStorage.getItem("productThumbnail"): this.state.productThumbnail,
                    ProductThumbnail: values.productThumbnail,
                    productThumbnailDocId: localStorage.getItem("prdthumbnail")
                      ? localStorage.getItem("prdthumbnail")
                      : this.state.productThumbnailDocId,
                    // productLink: values.productLink.trim(),
                    // Please dont remove localStorage
                    // productVideourl: this.state.productVideourl,
                    productVideourl: values.productVideourl,
                    descFile: values.descriptionFile,
                    productVidoeDocId: localStorage.getItem("prdvideourl")
                      ? localStorage.getItem("prdvideourl")
                      : this.state.productVidoeDocId,
                    partnerPartyID: values.partnerPartyID,
                    partner: values.partner,
                    partnerID: values.partner,
                    isParentProduct: 1,
                    parentProductID: values.parentProductID,
                    // hasModules: hasModule,
                    hasModules: 1,
                    // isDisplayinCourseCatalog: isDisplayinCourseCatalog,
                    isDisplayinCourseCatalog:1,
                    // buid: values.buid,
                    // productAnchor: values.productAnchor.trim(),
                    // productSubtitle: values.productSubtitle.trim(),
                    // productLanguage: values.productLanguage,
                    productDescription: values.productDescription.trim(),
                    productType: values.productType,
                    // productCode: values.productCode,
                    // productPrice: values.productPrice,
                    // productDisplaySequence: parseInt(values.productSequence),
                    productDisplaySequence:null,
                    //isActive: values.status,
                    isActive: values.isActive,
                    createdBy: localStorage.getItem("userid-Token"),
                    createdDate: values.createdDate
                      ? moment(today).format("DD/MM/YYYY HH:mm:ss")
                      : values.createdDate,
                    lastModifiedBy: values.lastModifiedBy,
                    lastModifiedDate: values.lastModifiedDate,
                    productMinPassingScore: ([2,"2"].includes(values.courseTypeID) && values.questionnaireData.length > 0)?
                      (values.productMinPassingScore === 0 ? 0 : values.productMinPassingScore ? parseInt(values.productMinPassingScore) : "") : "",
                    totalScore: ([2,"2"].includes(values.courseTypeID) && values.questionnaireData.length > 0)?
                    (values.totalScore === 0 ? 0 : values.totalScore ? parseInt(values.totalScore) : "") : "",
                    //status: values.status,
                    productTypeList: values.productTypeList,
                    partnerList: values.partnerList,
                    statusList: values.statusList,
                    modifiedBy: localStorage.getItem("userid-Token"),

                    document: values.document,

                    // categoryID:
                    //   values.subCategory && !Array.isArray(values.subCategory)
                    //     ? values.subCategory
                    //     : values.category,
                    categoryID:
                    values.productType === "10502"
                      ? values.category
                        ? values.category
                        : null
                      : null,
                    isFree:values.topFree==="Y"?"Y":values.isFree ? values.isFree : "N",
                    productPrice:
                      values.isFree === "Y"
                        ? 0
                        // : Number(values.productPrice).toFixed(2),
                        : Math.round(values.productPrice),
                    // duration: formattedTime,
                    duration:
                    [10502,"10502"].includes(values.productType)
                      ? 
                        values.durationDH === "hours" ? formattedTime 
                        : values.durationDH === "days" ? `${values.durationDays} ${values.durationDH}` 
                        : null
                      : null,
                    gcubeID:
                      values.gcubeId === 0
                        ? 0
                        : values.gcubeId
                        ? parseInt(values.gcubeId)
                        : null,
                   topFree:["1",1].includes(values.courseTypeID)?values.topFree ? values.topFree : null:null,
                   lookForID: values.lookingFor ? values.lookingFor : 0,
                   levelID: values.level ? values.level : 0,
                   isMostPopular : values.mostPopular ? values.mostPopular : null,
                   durationType:values.durationDH,
                   courseTypeID:values.courseTypeID?values.courseTypeID:"",
                   strikethroughPrice:values.isFree === "Y"
                   ?""
                   :values.strikethroughPrice?Math.round(values.strikethroughPrice):"",
                   addOnProductEntityList:values.selectedAddOnCourses?values.selectedAddOnCourses:[],
                   admissionLetterDocID:(["2",2].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor))?(localStorage.getItem("admissionPdfID")?localStorage.getItem("admissionPdfID"):""):"",
                   admissionLetterDocURL:(["2",2].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor))?(localStorage.getItem("admissionPdf")?localStorage.getItem("admissionPdf"):values.admissionPdf):"",
               
                  };
                  console.log("DATA",data);
                  this.setState({ loading: true });
                  ProductService.updateProduct(
                    data,
                    (cb) => {
                      //console.log("CB", cb.status);

                      if (cb.status === "success") {
                        //console.log("CB.STATUS", cb.status);
                      if([1,"1"].includes(values.courseTypeID)){
                        this.setState({ loading: false });
                        success(
                          "Course updated successfully!",
                          successNotification
                        );

                        // Please dont remove localStorage
                        localStorage.setItem("reload", true);
                        window.localStorage.removeItem("prdthumbnail");
                        window.localStorage.removeItem("productThumbnail");
                        window.localStorage.removeItem("prdvideourl");
                        window.localStorage.removeItem("productVideourl");
                        window.localStorage.removeItem("descFile");  
                        window.localStorage.removeItem("brochurePdf");
                        window.localStorage.removeItem("admissionPdf");
                        window.localStorage.removeItem("admissionPdfID"); 
                        this.props.history.push("/ops-course-list");
                      }else if([2,"2"].includes(values.courseTypeID)){
                        let questionData = [...this.state.questionnaireData];
                        questionData.map((item, index) => {
                          item.productID = cb.responseObject.productID;
                        });
                        if(questionData.length === 0){
                          questionData = 
                          [
                            {
                              productID: cb.responseObject.productID,
                              optionDescEntityList: []
                            }
                          ]
                        }
                        window.localStorage.removeItem("prdthumbnail");
                        window.localStorage.removeItem("productThumbnail");
                        window.localStorage.removeItem("prdvideourl");
                        window.localStorage.removeItem("descFile");
                        window.localStorage.removeItem("brochurePdf");
                        window.localStorage.removeItem("admissionPdf");
                        window.localStorage.removeItem("admissionPdfID"); 
                        window.localStorage.removeItem("productVideourl");
                        StudentAssessmentService.updateQuestionnaire(
                          questionData,
                          (res) => {
                            if (res.status === "success") {
                              this.setState({ loading: false });
                              success("Course updated successfully!", successNotification);
                              this.props.history.push("/ops-course-list");
                            }else{
                              this.setState({ loading: false,submitBtnClick: false });
                              warning(res.reasonText, warningNotification);
                              return;
                            }
                          }
                        );
                      }
                      } else {
                        this.setState({submitBtnClick:false ,loading: false });
                        // error(cb.reasonText, {
                        //   ...errorNotification,
                        //   container: "top-center"
                        // });
                        // warning(cb.reasonText ? cb.reasonText : cb.status, warningNotification);
                        warning(cb.reasonText ? cb.reasonText : cb.status, {
                          ...warningNotification,
                          container: "top-center",
                        });
                      }
                    },
                    (err) => console.log("Error", err)
                  );
                }, 1000);
              }
            }
        //      else if (isSequenceDuplicate) {
        //       warning(
        //         "Sequence Number is already assigned to the Product, Please change the Sequnece Number",
        //         {
        //           ...warningNotification,
        //           container: "top-center",
        //         }
        //       );
        //       this.setState({ loading: false });
        //     }
        //   });
        // }
          }
      }
        render={({
          errors,
          touched,
          handleSubmit,
          handleChange,
          values,
          setFieldValue,
          setFieldTouched,
          ...formikProps
        }) => (
          <React.Fragment>
              {(this.state.loading || this.state.loading1|| this.state.loading2) && (
              <PopUpPortal
                HidePopup={this.state.loading||this.state.loading1||this.state.loading2}
                IsVisible={this.state.loading||this.state.loading1||this.state.loading2}
              />
            )}
            {/* <div>
              <pre>{JSON.stringify(values, null, 2)}</pre>
            </div> */}
            <section className="dashboard-tab user-profile pt-50 mb-50">
              <Form
                onSubmit={handleSubmit}
                onKeyDown={(onKeyDown) => {
                  if (
                    (onKeyDown.charCode || onKeyDown.keyCode) === 13 &&
                    onKeyDown.target.name !== "productLanguage" &&
                    onKeyDown.target.name !== "submitForm" &&
                    onKeyDown.target.name !== "cancelForm"
                  ) {
                    onKeyDown.preventDefault();
                  }
                }}
                className="form-group"
              >
                <div className="">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pt-130">
                        <div className="bg-box">
                          <section className="create-user" id="create-user">
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">Course Details</h2>
                                <div className="form-group">
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Type{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        disabled
                                        as="select"
                                        name="productType"
                                        id="productType"
                                        onChange={()=>{
                                          if(!this.state.isEdit)
                                          handleChange();
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.productType &&
                                          touched.productType
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        {<option value="">--Select--</option>}

                                        {this.state.productTypeList
                                          ? this.state.productTypeList.map(
                                              (team) => (
                                                <option
                                                  key={team.codeValueId}
                                                  value={team.codeValueId}
                                                >
                                                  {team.codeValue}
                                                </option>
                                              )
                                            )
                                          : ""}
                                      </Field>
                                      <ErrorMessage
                                        name="productType"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Status{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="isActive"
                                        id="isActive"
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          this.setState({
                                            isActive: event.target.value,
                                          });
                                        
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.isActive && touched.isActive
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>
                                        {/* <option value="1">Active</option>
                                        <option value="0">InActive</option> */}
                                        {/* //{this.props.status.map(team => ( */}
                                        {this.state.statusList
                                          ? this.state.statusList.map(
                                              (team) => (
                                                <option
                                                  key={team.codeValueId}
                                                  value={team.codeValueId}
                                                >
                                                  {team.codeValue}
                                                </option>
                                              )
                                            )
                                          : ""}
                                        {/*
                                {this.state.productTypeList ? this.state.productTypeList.map(team => (

                                                    <option
                                                      key={team.codeValueId}
                                                      value={team.codeValueId}
                                                    >
                                                      {team.codeValue}
                                                    </option>
                                                  )) : "" } */}
                                      </Field>
                                      <ErrorMessage
                                        name="isActive"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    {[10502, "10502"].includes(values.productType) && (
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Type of Course{" "}
                                      <span className="validation"> *</span> </label>
                                      <Field
                                        as="select"
                                        name="courseTypeID"
                                        id="courseTypeID"
                                        disabled={true}
                                        onChange={()=>{
                                          if(!this.state.isEdit)
                                          handleChange();
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.courseTypeID &&
                                          touched.courseTypeID
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                       <option value="">--Select--</option>
                                        {values.TypeOfCourseList&&values.TypeOfCourseList.map((team) => (
                                          <option
                                            key={team.courseTypeID}
                                            value={team.courseTypeID}
                                          >
                                            {team.courseTypeName}
                                          </option>
                                        ))}

                                      </Field>
                                      <ErrorMessage
                                        name="courseTypeID"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                     )}
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Name{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productName"
                                        id="productName"
                                        maxLength={255}
                                        // disabled={true}
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          this.setState({
                                            productName: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.productName &&
                                          touched.productName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Name"
                                      />
                                      <ErrorMessage
                                        name="productName"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Code </label>
                                      <Field
                                        type="text"
                                        name="productCode"
                                        maxLength={255}
                                        id="productCode"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productCode &&
                                          touched.productCode
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Code"
                                      />
                                      <ErrorMessage
                                        name="productCode"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Link</label>
                                      <Field
                                        type="text"
                                        name="productLink"
                                        id="productLink"
                                        maxLength={255}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productLink &&
                                          touched.productLink
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="product Link"
                                      />
                                      <ErrorMessage
                                        name="productLink"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Partner{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        as="select"
                                        name="partner"
                                        id="partner"
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          this.setState({
                                            partnerID: event.target.value,
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.partner && touched.partner
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>

                                        {this.props.partner.map((team) => (
                                          <option
                                            key={team.partnerID}
                                            value={team.partnerID}
                                          >
                                            {team.partnerName}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="partner"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  {/* <div className="row"> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          BUID
                                          <span className="validation"> *</span>
                                          </label>
                                        <Field
                                          type="text"
                                          name="buid"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.buid &&
                                            touched.buid
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="buid"
                                        />
                                        <ErrorMessage
                                          name="buid"
                                          className="validation"
                                          component="div"
                                        />
                                      </div> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        HasModules
                                          <span className="validation"> *</span>
                                        </label>
                                      <Field
                                              className="form-check-input"
                                              type="checkbox"
                                              name="sameAsAbove"
                                              // checked={
                                              //   this.state.checkAddressFlag
                                              // }
                                              // onClick={
                                              //   this.assignPerAddressSameAsCores
                                              // }
                                            />
                                            </div> */}

                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Anchor</label>
                                      <Field
                                        type="text"
                                        name="productAnchor"
                                        maxLength={1000}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productAnchor &&
                                          touched.productAnchor
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Anchor"
                                      />
                                      <ErrorMessage
                                        name="productAnchor"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Subtitle</label>
                                      <Field
                                        type="text"
                                        name="productSubtitle"
                                        maxLength={1000}
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productSubtitle &&
                                          touched.productSubtitle
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Subtitle"
                                      />
                                      <ErrorMessage
                                        name="productSubtitle"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Language </label>
                                      <Field
                                        as="select"
                                        name="productLanguage"
                                        maxLength={1000}
                                        id="productLanguage"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productLanguage &&
                                          touched.productLanguage
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option> */}
                                        {/* {values.productLanguage.map(team => (
                                                <option
                                                  key={team.productLanguageId}
                                                  value={team.productLanguageId}
                                                >
                                                  {team.productLanguage}
                                                </option>
                                              ))} */}
                                        {/* <option value="1">English</option>
                                      </Field>
                                      <ErrorMessage
                                        name="productLanguage"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Price
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productPrice"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productPrice &&
                                          touched.productPrice
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Course Price"
                                      />
                                      <ErrorMessage
                                        name="productPrice"
                                        className="validation"
                                        component="div"
                                      />
                                      </div> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Position / Sequence</label>
                                      <span className="validation"> *</span>
                                      <Field
                                        type="text"
                                        name="productSequence"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productSequence &&
                                          touched.productSequence
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Position / Sequence"
                                      />
                                      <ErrorMessage
                                        name="productSequence"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                  */}
                               {/* <div className="row"> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Position / Sequence</label>
                                      <span className="validation"> *</span>
                                      <Field
                                        type="text"
                                        name="productSequence"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productSequence &&
                                          touched.productSequence
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Position / Sequence"
                                      />
                                      <ErrorMessage
                                        name="productSequence"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <Field
                                        type="checkbox"
                                        name="isDisplayinCourseCatalog"
                                      />
                                      <label>&nbsp; Visible</label>
                                      <div className="form-field-error">
                                        {errors.isDisplayinCourseCatalog}
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <Field
                                        type="checkbox"
                                        name="hasModules"
                                        onChange={handleChange}
                                      />
                                      <label> &nbsp; Modules</label>
                                      <div className="form-field-error">
                                        {errors.hasModules}
                                      </div>
                                    </div> */}
                                    {/* {values.productType === "10502" && (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        
                                        <Field
                                          type="checkbox"
                                          name="topFree"
                                          onChange={()=>{
                                            if(values.topFree==='N'){
                                              setFieldValue("topFree",'Y');
                                              setFieldValue("isFree",'Y');
                                            }
                                            else{
                                              setFieldValue("topFree","N")
                                            }
                                          }}

                                          checked={values.topFree==='Y'}
                                        />
                                        <label
                                          className="form-field"
                                          htmlFor="topFree"
                                        >
                                          <span>&nbsp;Top Free</span>
                                          
                                        </label>
                                        <div className="form-field-error">
                                          {errors.topFree}
                                        </div>
                                      </div>
                                    )} */}

                                    {/* {values.productType.toString() !==
                                      "10502" && (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Price
                                          <span className="validation"> *</span>
                                        </label>
                                        <Field
                                          type="text"
                                          name="productPrice"
                                          onChange={handleChange}
                                          className={
                                            "form-control" +
                                            (errors.productPrice &&
                                            touched.productPrice
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Course Price"
                                        />
                                        <ErrorMessage
                                          name="productPrice"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    )} */}

                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Product Thumbnail{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productThumbnail"
                                        id="productThumbnail"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productThumbnail && touched.productThumbnail
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Thumbnail"
                                      />
                                      <ErrorMessage
                                        name="productThumbnail"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                  {/* </div> */}
                                  {[10502, "10502"].includes(values.productType)&& (
                                    <div className="row">
                                      {["1",1].includes(values.courseTypeID)&&(
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <Field
                                          type="checkbox"
                                          name="topFree"
                                          onChange={(event)=>{
                                            if(values.topFree==='N'){
                                              setFieldValue("topFree",'Y');
                                              setFieldValue("isFree",'Y');
                                            }
                                            else{
                                              setFieldValue("topFree","N")
                                            }
                                          }}
                                          onBlur={(event) => {
                                            let fetchProductDetailUpdated=fetchProductDetail;
                                            // fetchProductDetailUpdated.topFree=event.target.value;
                                            if(event.target.checked){
                                              fetchProductDetailUpdated.topFree = "Y"
                                              fetchProductDetailUpdated.isFree = "Y"
                                            }else{
                                              fetchProductDetailUpdated.topFree = "N"
                                            }                                            
                                            // if(values.topFree==='Y'){
                                            //   fetchProductDetailUpdated.isFree = "Y"
                                            // }
                                            this.setState({
                                              fetchProductDetail:fetchProductDetailUpdated
                                            });
                                          }}
                                          checked={values.topFree==='Y'}
                                        />
                                        <label
                                          className="form-field"
                                          htmlFor="topFree"
                                        >
                                          <span>&nbsp;Top Free</span>
                                        </label>
                                        <div className="form-field-error">
                                          {errors.topFree}
                                        </div>
                                      </div>
                                      )}
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                      <Field
                                        type="checkbox"
                                        name="mostPopular"
                                        onChange={() => {
                                          // if (values.mostPopular === "" || values.mostPopular === null) {
                                          if (["",null,undefined].includes(values.mostPopular)) {
                                            setFieldValue("mostPopular", "Y");
                                          } else {
                                            setFieldValue("mostPopular", null);
                                          }
                                        }}
                                        onBlur={(event) => {
                                          let fetchProductDetailUpdated=fetchProductDetail;
                                          // fetchProductDetailUpdated.isMostPopular=event.target.value;                                            
                                          if(event.target.checked){
                                            fetchProductDetailUpdated.isMostPopular = "Y"
                                          }else{
                                            fetchProductDetailUpdated.isMostPopular = null
                                          }
                                          this.setState({
                                            fetchProductDetail:fetchProductDetailUpdated
                                          });
                                        }}
                                        checked={values.mostPopular==='Y'}
                                      />
                                      <label
                                        className="form-field"
                                        htmlFor="mostPopular"
                                      >
                                        <span>&nbsp;Most Popular</span>
                                      </label>
                                      <div className="form-field-error">
                                        {errors.mostPopular}
                                      </div>
                                    </div>                                    
                                  </div>
                                    )}

                                  <div className="row">
                                    {[10502, "10502"].includes(
                                      values.productType
                                    ) && (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                    <label>Gcube ID{" "}
                                          <span className="validation"> *</span>
                                           </label>
                                        <Field
                                          type="text"
                                          maxLength={10}
                                          name="gcubeId"
                                          id="gcubeId"
                                          onChange={handleChange}
                                          onBlur={(event) => {
                                            let fetchProductDetailUpdated=fetchProductDetail;
                                            fetchProductDetailUpdated.gcubeID=event.target.value;                                            
                                            this.setState({
                                              fetchProductDetail:fetchProductDetailUpdated
                                            });
                                          }}
                                          title={values.gcubeId}
                                          value={values.gcubeId}
                                          placeholder="Gcube ID"
                                          className={
                                            "form-control" +
                                            (errors.gcubeId && touched.gcubeId
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="gcubeId"
                                          className="validation "
                                          component="div"
                                        />
                                      </div>
                                    )}
                                    {[10502, "10502"].includes(
                                      values.productType
                                    )&&values.topFree!=="Y"&& (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Is Free{" "}
                                          <span className="validation"> *</span>
                                        </label>

                                        <Field
                                          as="select"
                                          name="isFree"
                                          id="isFree"
                                          onChange={handleChange}
                                          onBlur={(event) => {
                                            let fetchProductDetailUpdated=fetchProductDetail;
                                            fetchProductDetailUpdated.isFree=event.target.value;                                            
                                            this.setState({
                                              fetchProductDetail:fetchProductDetailUpdated
                                            });
                                          }}
                                          value={values.isFree}
                                          title={values.isFree}
                                          className={
                                            "form-control" +
                                            (errors.isFree && touched.isFree
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option>-- Select --</option>
                                          <option value="N">No</option>
                                          <option value="Y">Yes</option>
                                        </Field>
                                        <ErrorMessage
                                          name="isFree"
                                          className="validation "
                                          component="div"
                                        />
                                      </div>
                                    )}

                                    {/* {values.isFree === "N" && (
                                          <div className="col-md-4 col-sm-6 col-xs-12">
                                            <label>
                                              Price
                                              <span className="validation">
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <Field
                                              type="text"
                                              name="productPrice"
                                              onChange={handleChange}
                                              className={
                                                "form-control" +
                                                (errors.productPrice &&
                                                touched.productPrice
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="Course Price"
                                            />
                                            <ErrorMessage
                                              name="productPrice"
                                              className="validation"
                                              component="div"
                                            />
                                          </div>
                                        )} */}

                                    {/* {(values.productType !== "" &&
                                        values.productType !== "10502"
                                          ? true
                                          : values.isFree === "N"
                                          ? true
                                          : false) && (
                                          <div className="col-md-4 col-sm-6 col-xs-12">
                                            <label>
                                              Price
                                              <span className="validation">
                                                {" "}
                                                *
                                              </span>
                                            </label>
                                            <Field
                                              type="number"
                                              name="productPrice"
                                              onChange={handleChange}
                                              className={
                                                "form-control" +
                                                (errors.productPrice &&
                                                touched.productPrice
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="Course Price"
                                            />
                                            <ErrorMessage
                                              name="productPrice"
                                              className="validation"
                                              component="div"
                                            />
                                          </div>
                                        )} */}

                                    {(values.productType.toString() !== "10502"
                                      ? true
                                      : values.isFree === "N"
                                      ? true
                                      : false) && (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Price
                                          <span className="validation"> *</span>
                                        </label>
                                        <Field
                                          type="text"
                                          name="productPrice"
                                          id="productPrice"
                                          maxLength={9}
                                          onChange={handleChange}
                                          onBlur={(event) => {
                                            this.setState({
                                              productPrice:event.target.value
                                            });
                                          }}
                                          className={
                                            "form-control" +
                                            (errors.productPrice &&
                                            touched.productPrice
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Course Price"
                                        />
                                        <ErrorMessage
                                          name="productPrice"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="row">
                                  {/* {values.productType === "10502" && ( */}
                                   {/* )} */}
                                    {values.productType === "10502"&&[2,"2"].includes(values.courseTypeID)&&values.isFree==="N"&&
                                 <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                      Strikethrough Price{" "}
                                        {/* <span className="validation"> *</span> */}
                                      </label>
                                      <Field
                                        type="text"
                                        name="strikethroughPrice"
                                        id="strikethroughPrice"
                                        maxLength={9}
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          let fetchProductDetailUpdated=fetchProductDetail;
                                          fetchProductDetailUpdated.strikethroughPrice=event.target.value;                                            
                                          this.setState({
                                            fetchProductDetail:fetchProductDetailUpdated
                                          });
                                        }}
                                        // onChange={(e)=>{
                                        //   handleChange(e);
                                        //  this.handleNumberChange1(e,setFieldValue);
                                        // }}
                                        className={
                                          "form-control" +
                                          (errors.strikethroughPrice &&
                                          touched.strikethroughPrice
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Strikethrough Price"
                                      />
                                      <ErrorMessage
                                        name="strikethroughPrice"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                     }
                      {([10502, "10502"].includes(values.productType))&&
                        <div 
                        id="selectedAddOnCourses"
                        className="col-md-4 col-sm-6 col-xs-12">
                         <label>
                             Add-on Courses{" "}
                           </label>   
                          <Field
                            name="selectedAddOnCourses"
                            options={createOptions1(values.addOnCourseList ? values.addOnCourseList : [], 'productid', 'productName')}
                            component={CustomSelect}
                            placeholder="Select Add On Courses..."
                            isMulti={true}
                            handleCallback={()=>{
                              this.setState({
                                selectedAddOnCourses:values.selectedAddOnCourses
                              })
                            }}
                            error={errors.selectedAddOnCourses}
                          />
                        </div>  
        }     
                                  </div>
                                  {[10502, "10502"].includes(
                                    values.productType
                                  ) && (
                                    <div className="row">
                                       {[10502, "10502"].includes(values.productType) && (
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Duration in Days/Hours{" "}
                                      <span className="validation"> *</span> </label>
                                      <Field
                                        as="select"
                                        name="durationDH"
                                        id="durationDH"
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          let fetchProductDetailUpdated=fetchProductDetail;
                                          fetchProductDetailUpdated.durationType=event.target.value;                                            
                                          this.setState({
                                            fetchProductDetail:fetchProductDetailUpdated
                                          });
                                        }}
                                        value={values.durationDH}
                                        className={
                                          "form-control" +
                                          (errors.durationDH &&
                                          touched.durationDH
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value="">--Select--</option>
                                        <option value="hours">Hours</option>
                                        <option value="days">Days</option>
                                      </Field>
                                      <ErrorMessage
                                        name="durationDH"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    )}
                                      {values.durationDH === "hours" ?
                                      <div id="durationinhours" className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Duration in Hours{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                            <Field
                                              as="select"
                                              name="hours"
                                              id="hours"
                                              onChange={(e) => {
                                                setFieldValue(
                                                  (values.hours =
                                                    e.target.value)
                                                );
                                              }}
                                              onBlur={(event) => {
                                                let fetchProductDetailUpdated=fetchProductDetail;
                                                fetchProductDetailUpdated.hours=event.target.value;                                            
                                                this.setState({
                                                  fetchProductDetail:fetchProductDetailUpdated
                                                });
                                              }}
                                              className={
                                                "form-control " +
                                                (errors.hours && touched.hours
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">HH</option>
                                              {(values.listOfHours || []).map(
                                                (h, index) => (
                                                  <option key={index} value={h}>
                                                    {" "}
                                                    {h}{" "}
                                                  </option>
                                                )
                                              )}
                                            </Field>
                                            <ErrorMessage
                                              name="hours"
                                              className="validation "
                                              component="div"
                                            />
                                          </div>
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                            <Field
                                              as="select"
                                              name="minutes"
                                              id="minutes"
                                              onChange={(e) => {
                                                setFieldValue(
                                                  (values.minutes =
                                                    e.target.value)
                                                );
                                              }}
                                              onBlur={(event) => {
                                                let fetchProductDetailUpdated=fetchProductDetail;
                                                fetchProductDetailUpdated.minutes=event.target.value;                                            
                                                this.setState({
                                                  fetchProductDetail:fetchProductDetailUpdated
                                                });
                                              }}
                                              className={
                                                "form-control " +
                                                (errors.minutes &&
                                                touched.minutes
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">MM</option>
                                              {(values.listOfMins || []).map(
                                                (m, index) => (
                                                  <option key={index} value={m}>
                                                    {" "}
                                                    {m}{" "}
                                                  </option>
                                                )
                                              )}
                                            </Field>
                                            <ErrorMessage
                                              name="minutes"
                                              className="validation "
                                              component="div"
                                            />
                                          </div>
                                          <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                            <Field
                                              as="select"
                                              name="seconds"
                                              id="seconds"
                                              onChange={(e) => {
                                                setFieldValue(
                                                  (values.seconds =
                                                    e.target.value)
                                                );
                                              }}
                                              onBlur={(event) => {
                                                let fetchProductDetailUpdated=fetchProductDetail;
                                                fetchProductDetailUpdated.seconds=event.target.value;                                            
                                                this.setState({
                                                  fetchProductDetail:fetchProductDetailUpdated
                                                });
                                              }}
                                              className={
                                                "form-control " +
                                                (errors.seconds &&
                                                touched.seconds
                                                  ? "is-invalid"
                                                  : "")
                                              }
                                            >
                                              <option value="">SS</option>
                                              {(
                                                this.state.listOfSecs || []
                                              ).map((s, index) => (
                                                <option key={index} value={s}>
                                                  {" "}
                                                  {s}{" "}
                                                </option>
                                              ))}
                                            </Field>
                                            <ErrorMessage
                                              name="seconds"
                                              className="validation "
                                              component="div"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      : 
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Duration in Days{" "}
                                      <span className="validation"> *</span> </label>
                                      <Field
                                        type="text"
                                        maxLength={2}
                                        name="durationDays"
                                        id="durationDays"
                                        value={values.durationDays}
                                        placeholder="Duration in Days"
                                        onChange={(e)=>{ handleChange(e);
                                          this.handleNumberChange(e,setFieldValue,"durationDays");
                                        }}
                                        onBlur={(event) => {
                                          let fetchProductDetailUpdated=fetchProductDetail;
                                          fetchProductDetailUpdated.durationDays=event.target.value;                                            
                                          this.setState({
                                            fetchProductDetail:fetchProductDetailUpdated
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.durationDays &&
                                          touched.durationDays
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="durationDays"
                                        component="div"
                                        className="validation"
                                      />
                                      {this.state.durationDaysValidate1 ? <p style={{color:"red",fontSize:"13px"}}>You cannot add less than 1 day</p> : ""}
                                      {this.state.durationDaysValidate2 ? <p style={{color:"red",fontSize:"13px"}}>You cannot add more than 90 days</p> : ""}
                                    </div>
                                    }
                                   
                                      {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>Sub Category </label>
                                        <Field
                                          as="select"
                                          name="subCategory"
                                          id="subCategory"
                                          onChange={(event) => {
                                            var level = 0;
                                            for (var option of event.target
                                              .options) {
                                              if (option.selected) {
                                                level =
                                                  option.getAttribute(
                                                    "data-level"
                                                  );
                                                setFieldValue(
                                                  (values.categoryLevel = level)
                                                );
                                                setFieldValue(
                                                  (values.subCategory =
                                                    option.value)
                                                );
                                              }
                                            }
                                          }}
                                          value={values.subCategory}
                                          title={values.subCategory}
                                          className={
                                            "form-control" +
                                            (errors.subCategory &&
                                            touched.subCategory
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <>
                                            <option value={""}>
                                              -- Select --
                                            </option>


                                            {this.state.allSubCategories.map(
                                              (data) => (
                                                <option
                                                  value={data.categoryID}
                                                  data-level={
                                                    data.categoryLevel
                                                  }
                                                >
                                                  {data.categoryName}
                                                </option>
                                              )
                                            )}
                                          </>
                                        </Field>
                                        <ErrorMessage
                                          name="subCategory"
                                          className="validation "
                                          component="div"
                                        />
                                      </div> */}
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Category{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                        <Field
                                          as="select"
                                          name="category"
                                          id="category"
                                          // onChange={(event) => {

                                          //     // handleChange(event)
                                          //     setFieldValue(
                                          //         "category",
                                          //         event.target.value
                                          //       );
                                          //       setFieldValue("categoryLevel", 0)
                                          //       setFieldValue("subCategory","")
                                          //       this.selectCategory(event.target.value,setFieldValue)

                                          //         }
                                          //         }
                                          onChange={(event) => {
                                            // var level = 0;
                                            for (var option of event.target
                                              .options) {
                                              if (option.selected) {
                                                setFieldValue(
                                                  (values.categoryLevel = 0)
                                                );
                                                setFieldValue(
                                                  (values.category =
                                                    option.value)
                                                );
                                                this.selectCategory(
                                                  event.target.value,
                                                  setFieldValue
                                                );
                                              }
                                            }
                                          }}
                                          onBlur={(event) => {
                                            let fetchProductDetailUpdated=fetchProductDetail;
                                            fetchProductDetailUpdated.categoryID=event.target.value;                                            
                                            this.setState({
                                              fetchProductDetail:fetchProductDetailUpdated
                                            });
                                          }}
                                          value={values.category}
                                          title={values.category}
                                          className={
                                            "form-control" +
                                            (errors.category && touched.category
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option value="">-- Select--</option>
                                          {this.state.allCategories.map(
                                            (data) => (
                                              <option
                                                value={data.categoryID}
                                                // title={data.categoryName}
                                              >
                                                {data.categoryName}
                                              </option>
                                            )
                                          )}
                                        </Field>
                                        <ErrorMessage
                                          name="category"
                                          className="validation "
                                          component="div"
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {[10502, "10502"].includes(values.productType) && (
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Looking For {" "}
                                      <span className="validation"> *</span></label>

                                      <Field
                                        as="select"
                                        name="lookingFor"
                                        id="lookingFor"
                                        onChange={handleChange}
                                        onBlur={(event) => {
                                          let fetchProductDetailUpdated=fetchProductDetail;
                                          fetchProductDetailUpdated.lookForID=event.target.value;                                            
                                          this.setState({
                                            fetchProductDetail:fetchProductDetailUpdated
                                          });
                                        }}
                                        title={values.lookingFor}
                                        value={values.lookingFor}
                                        className={
                                          "form-control" +
                                          (errors.lookingFor &&
                                          touched.lookingFor
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <>
                                          <option value={""}>-- Select --</option>
                                          {(this.state.iamLookingFor || []).map(
                                            (item) => (
                                              <option
                                                key={item.lookForID}
                                                value={item.lookForID}
                                              >
                                                {item.lookFor}
                                              </option>
                                            )
                                            )}
                                        </>
                                      </Field>
                                      <ErrorMessage
                                        name="lookingFor"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    { values.isShow === true && (
                                    <>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Minimum Passing Score
                                      <span className="validation"> *</span></label>
                                      <Field
                                        type="text"
                                        name="productMinPassingScore"
                                        id="productMinPassingScore"
                                        maxLength={10}
                                        // onChange={handleChange}
                                        onChange={(e)=>{ handleChange(e);
                                          this.handleNumberChange(e,setFieldValue,"productMinPassingScore");
                                        }}
                                        onBlur={(event) => {
                                          this.setState({
                                            productMinPassingScore:event.target.value
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.productMinPassingScore &&
                                          touched.productMinPassingScore
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Minimum Passing Score"
                                      />
                                      <ErrorMessage
                                        name="productMinPassingScore"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Total Score
                                      <span className="validation"> *</span></label>
                                      <Field
                                        type="text"
                                        name="totalScore"
                                        id="totalScore"
                                        maxLength={10}
                                        disabled
                                        onChange={()=>{if(!this.state.isEdit)handleChange();}}
                                        // onChange={(e)=>{ handleChange(e);
                                        //   this.handleNumberChange(e,setFieldValue,"totalScore");
                                        // }}
                                        onBlur={(event) => {
                                          this.setState({
                                            totalScore:event.target.value
                                          });
                                        }}
                                        className={
                                          "form-control" +
                                          (errors.totalScore &&
                                          touched.totalScore
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Total Score"
                                      />
                                      <ErrorMessage
                                        name="totalScore"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    </>
                                    )}
                                  </div>
                                  )}
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Thumbnail</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                        {values.productThumbnail&&
                                          <img
                                            className="profile-pic"
                                            src={values.productThumbnail}
                                            alt="img"
                                          />
                                        }
                                          {/* <div className="profile">
                                            <i
                                              className="fa fa-user"
                                              aria-hidden="true"
                                            ></i>
                                          </div> */}
                                        </div>
                                      </div>
                                      <div className="profile-add">
                                        <span className="icon btn-file text-center">
                                          <i
                                            className="fa fa-plus-circle"
                                            aria-hidden="true"
                                          ></i>
                                          <FileBase64
                                            multiple={true}
                                            onChange={handleChange}
                                            // onDone={(event) => {
                                            //   if (
                                            //     [
                                            //       "image/jpg",
                                            //       "image/jpeg",
                                            //       "image/png",
                                            //     ].indexOf(event[0].type) < 0
                                            //   ) {
                                            //     setFieldValue(
                                            //       (values.documentTypeCheckForProductTImage = true)
                                            //     );
                                            //     setFieldValue(values.documentSizeCheckForProductCheck = false)
                                            //   } else if (
                                            //     event[0].file.size <= 512000
                                            //   ) {
                                            //     values.document.push({
                                            //       documentHash: event[0].base64,
                                            //       documentType:
                                            //         "ProductThumbNail",
                                            //       documentName:
                                            //         event[0].name.split(
                                            //           "."
                                            //         )[0] + ".png",
                                            //     });

                                            //     setFieldValue(
                                            //       (values.documentTypeCheckForProductTImage = false)
                                            //     );
                                            //     setFieldValue(
                                            //       (values.documentSizeCheckForProductCheck = false)
                                            //     );
                                            //     values.productThumbnail =
                                            //       event[0].base64;
                                            //     setFieldValue(
                                            //       (values.productThumbnail =
                                            //         event[0].base64)
                                            //     );
                                            //   } else {
                                            //     setFieldValue(
                                            //       (values.documentSizeCheckForProductCheck = true)
                                            //     );
                                            //     setFieldValue(values.documentTypeCheckForProductTImage = false)
                                            //   }
                                            //   //alert("Base64 is ---- " + JSON.stringify(event[0].base64))
                                            // }}
                                            onDone={(event) => {
                                              if (
                                                [
                                                  "image/jpg",
                                                  "image/jpeg",
                                                  "image/png",
                                                ].indexOf(event[0].type) < 0
                                              ) {
                                                this.setState({ 
                                                  documentTypeCheckForProductTImage: true,
                                                  documentSizeCheckForProductCheck: false,
                                                });
                                              } else if (
                                                event[0].file.size <= 512000
                                              ) {                                              
                                                this.state.document.push({
                                                  documentHash: event[0].base64,
                                                  documentType:
                                                    "ProductThumbNail",
                                                  documentName:
                                                    event[0].name.split(
                                                      "."
                                                    )[0] + ".png",
                                                });
                                                this.setState({ 
                                                  documentTypeCheckForProductTImage: false,
                                                  documentSizeCheckForProductCheck: false,
                                                });
                                                let fetchProductDetailUpdated=fetchProductDetail;
                                                  fetchProductDetailUpdated.productThumbnail=event[0].base64;
                                                  this.setState({
                                                    fetchProductDetail:fetchProductDetailUpdated
                                                  });
                                              } else {
                                                this.setState({ 
                                                  documentTypeCheckForProductTImage: false,
                                                  documentSizeCheckForProductCheck: true,
                                                });
                                              }
                                            }}
                                          />
                                        </span>
                                        <h4>Add Image</h4>
                                        <div className="col-md-12 col-sm-12">
                                          <span className="file-size-limit">
                                            Supported Formats: .jpg, .jpeg, .png
                                            only. <br />
                                            File Size: Max 500 KB
                                          </span>
                                        </div>
                                        {values.documentSizeCheckForProductCheck ? (
                                          <p style={{ color: "red" }}>
                                            File Size is too large(Maximum File
                                            Size:500 KB).
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {values.documentTypeCheckForProductTImage ? (
                                          <p style={{ color: "red" }}>
                                            Invalid image format
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                    {/* <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Product Videourl
                                          <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="productVideourl"
                                        onChange={handleChange}
                                        className={
                                          "form-control" +
                                          (errors.productVideourl &&
                                            touched.productVideourl
                                            ? " is-invalid"
                                            : "")
                                        }
                                        placeholder="Product Videourl"
                                      />
                                      <ErrorMessage
                                        name="productVideourl"
                                        className="validation"
                                        component="div"
                                      />
                                    </div> */}
                                    {[10502, "10502"].includes(values.productType) && (
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Description File</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <div className="profile-pic">
                                            <div className="profile">
                                          <iframe className="descriptionFile"
                                            style={{ 
                                              width: "100%", 
                                          }}
                                            src={values.descriptionFile}
                                            type='application/pdf'
                                            title='title'
                                            frameBorder="0"
                                            scrolling="no"
                                          />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="profile-add">
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            <FileBase64
                                              multiple={true}
                                              name="descriptionFile"
                                              onChange={handleChange}
                                              // onDone={(event) => {                                               
                                              //   if (
                                              //     [
                                              //       "application/pdf",
                                              //     ].indexOf(event[0].type) < 0
                                              //   ) {                                                  
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForDescriptionFile = true)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForDescriptionFile = false)
                                              //     );
                                              //   } else if (
                                              //     event[0].file.size <= 200000 || event[0].file.size <= 204800
                                              //   ) {
                                              //     values.document.push({
                                              //       documentHash:
                                              //         event[0].base64,
                                              //       documentType:
                                              //         "ProductDescription",
                                              //       documentName: event[0].name,
                                              //     });
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForDescriptionFile = false)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForDescriptionFile = false)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.descriptionFile =
                                              //         event[0].base64)
                                              //     );
                                              //   } else {                                                  
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForDescriptionFile = true)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForDescriptionFile = false)
                                              //     );
                                              //   }
                                              // }}
                                              onDone={(event) => {                                               
                                                if (
                                                  [
                                                    "application/pdf",
                                                  ].indexOf(event[0].type) < 0
                                                ) {                                                  
                                                  this.setState({
                                                    documentTypeCheckForDescriptionFile: true,
                                                    documentSizeCheckForDescriptionFile: false,
                                                  });
                                                } else if (
                                                  event[0].file.size <= 200000 || event[0].file.size <= 204800
                                                ) {
                                                  this.state.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ProductDescription",
                                                    documentName: event[0].name,
                                                  });
                                                  this.setState({
                                                    documentTypeCheckForDescriptionFile: false,
                                                    documentSizeCheckForDescriptionFile: false,
                                                  });
                                                  let fetchProductDetailUpdated=fetchProductDetail;
                                                  fetchProductDetailUpdated.descFile=event[0].base64;
                                                  this.setState({
                                                    fetchProductDetail:fetchProductDetailUpdated
                                                  });
                                                } else {                                                  
                                                  this.setState({
                                                    documentTypeCheckForDescriptionFile: false,
                                                    documentSizeCheckForDescriptionFile: true,
                                                  });
                                                }
                                              }}
                                            />
                                          </span>
                                          <h4>Add Description File</h4>

                                          {values.documentSizeCheckForDescriptionFile ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum File Size:200 KB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForDescriptionFile ? (
                                            <p style={{ color: "red" }}>
                                              Invalid Format
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          

                                          <div className="col-md-12 col-sm-12">
                                            <span className="file-size-limit">
                                              Supported Formats: .pdf only. <br />
                                              File Size: Max 200 KB
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    )}  
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label> Video url</label>
                                      <div className="profile-detail">
                                        <div className="circle">
                                          <div className="profile-pic">
                                            <div className="profile">
                                              <ReactPlayer
                                                url={values.productVideourl}
                                                // playing
                                                controls
                                                autoPlay
                                                width="100%"
                                                height="100%"
                                              ></ReactPlayer>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div className="profile-add">
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            <FileBase64
                                              multiple={true}
                                              name="productVideourl"
                                              onChange={handleChange}
                                              onDone={(event) => {
                                                if (
                                                  [
                                                    "video/mp4",
                                                    "video/avi",
                                                    "video/mpeg",
                                                  ].indexOf(event[0].type) < 0
                                                ) {
                                                  setFieldValue(
                                                    (values.documentTypeCheckForVideo = true)
                                                  );
                                                  setFieldValue(values.documentSizeCheckForVideoCheck = false)
                                                } else if (
                                                  event[0].file.size <= 10000000
                                                ) {
                                                  values.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ProductVideourl",
                                                    documentName: event[0].name,
                                                  });
                                                  //alert('base64 is : ', JSON.stringify(event[0].base64))
                                                  setFieldValue(
                                                    (values.documentTypeCheckForVideo = false)
                                                  );
                                                  setFieldValue(
                                                    (values.documentSizeCheckForVideoCheck = false)
                                                  );
                                                  setFieldValue(
                                                    (values.productVideourl =
                                                      event[0].base64)
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    (values.documentSizeCheckForVideoCheck = true)
                                                  );
                                                  setFieldValue(values.documentTypeCheckForVideo = false)
                                                }
                                              }}
                                            />
                                          </span>
                                          <h4>Add Video</h4>

                                          {values.documentSizeCheckForVideoCheck ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum
                                              File Size:10MB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForVideo ? (
                                            <p style={{ color: "red" }}>
                                              Invalid Format
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          <div className="col-md-12 col-sm-12">
                                            <span className="file-size-limit">
                                              Supported Formats: .mp4, .avi,
                                              .mpeg only. <br />
                                              File Size: Max 10 MB
                                            </span>
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                    
                                  </div> 
                                  {[10502, "10502"].includes(values.productType) && (
                                    <div className="row">
                                      <div id="brochurePDF" className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Brochure PDF</label>
                                        <div className="profile-detail">
                                        <div className="circle">
                                          <div className="profile-pic">
                                            <div className="profile">
                                          <iframe className="brochurePdf"
                                            style={{ 
                                              width: "100%", 
                                          }}
                                            src={values.brochurePdf}
                                            type='application/pdf'
                                            title='title'
                                            frameBorder="0"
                                            scrolling="no"
                                          />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="profile-add">
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            <FileBase64
                                              multiple={true}
                                              name="brochurePdf"
                                              onChange={handleChange}
                                              // onDone={(event) => {                                               
                                              //   if (
                                              //     [
                                              //       "application/pdf",
                                              //     ].indexOf(event[0].type) < 0
                                              //   ) {                                                  
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForBrochure = true)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForBrochure = false)
                                              //     );
                                              //   } else if (
                                              //     event[0].file.size <= 512000
                                              //   ) {
                                              //     values.document.push({
                                              //       documentHash:
                                              //         event[0].base64,
                                              //       documentType:
                                              //         "ProductBrochure",
                                              //       documentName: event[0].name,
                                              //     });
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForBrochure = false)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForBrochure = false)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.brochurePdf =
                                              //         event[0].base64)
                                              //     );
                                              //   } else {                                                  
                                              //     setFieldValue(
                                              //       (values.documentSizeCheckForBrochure = true)
                                              //     );
                                              //     setFieldValue(
                                              //       (values.documentTypeCheckForBrochure = false)
                                              //     );
                                              //   }
                                              // }}
                                              onDone={(event) => {                                               
                                                if (
                                                  [
                                                    "application/pdf",
                                                  ].indexOf(event[0].type) < 0
                                                ) {                                                  
                                                  this.setState({ 
                                                    documentTypeCheckForBrochure: true,
                                                    documentSizeCheckForBrochure: false,
                                                  });
                                                } else if (
                                                  event[0].file.size <= 512000
                                                ) {
                                                  this.state.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ProductBrochure",
                                                    documentName: event[0].name,
                                                  });
                                                  this.setState({ 
                                                    documentTypeCheckForBrochure: false,
                                                    documentSizeCheckForBrochure: false,
                                                  });
                                                  let fetchProductDetailUpdated=fetchProductDetail;
                                                  fetchProductDetailUpdated.brochureFile=event[0].base64;
                                                  this.setState({
                                                    fetchProductDetail:fetchProductDetailUpdated
                                                  });
                                                } else {                                                  
                                                  this.setState({ 
                                                    documentTypeCheckForBrochure: false,
                                                    documentSizeCheckForBrochure: true,
                                                  });
                                                }
                                              }}
                                            />
                                          </span>
                                          <h4>Add Brochure PDF</h4>

                                          {values.documentSizeCheckForBrochure ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum File Size:500 KB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForBrochure ? (
                                            <p style={{ color: "red" }}>
                                              Invalid Format
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          <div className="col-md-12 col-sm-12">
                                            <span className="file-size-limit">
                                              Supported Formats: .pdf only. <br />
                                              File Size: Max 500 KB
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      </div>
                                      {([2,"2"].includes(values.courseTypeID)&&["9",9].includes(values.lookingFor))&&
                                  <div id="admissionPdf" className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Admission Letter
                                      <span className="validation"> *</span>
                                      </label>
                                        <div className="profile-detail">
                                        <div className="circle">
                                          <div className="profile-pic">
                                            <div className="profile">
                                          <iframe className="admissionPdf"
                                            style={{ 
                                              width: "100%", 
                                          }}
                                            src={values.admissionPdf}
                                            type='application/pdf'
                                            title='title'
                                            frameBorder="0"
                                            scrolling="no"
                                          />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="profile-add">
                                          <span className="icon btn-file text-center">
                                            <i
                                              className="fa fa-plus-circle"
                                              aria-hidden="true"
                                            ></i>
                                            <FileBase64
                                              multiple={true}
                                              name="admissionPdf"
                                              onChange={handleChange}
                                              onDone={(event) => {                                               
                                                if (
                                                  [
                                                    "application/pdf",
                                                  ].indexOf(event[0].type) < 0
                                                ) {                                                  
                                                  this.setState({ 
                                                    documentTypeCheckForAdmission: true,
                                                    documentSizeCheckForAdmission: false,
                                                  });
                                                } else if (
                                                  event[0].file.size <= 204800
                                                ) {
                                                  this.state.document.push({
                                                    documentHash:
                                                      event[0].base64,
                                                    documentType:
                                                      "ProductAdmissionLetter",
                                                    documentName: event[0].name,
                                                  });
                                                  this.setState({ 
                                                    documentTypeCheckForAdmission: false,
                                                    documentSizeCheckForAdmission: false,
                                                    // admissionPdf: event[0].base64
                                                  });
                                                  let fetchProductDetailUpdated=fetchProductDetail;
                                                  fetchProductDetailUpdated.admissionLetterDocURL=event[0].base64;
                                                  this.setState({
                                                    fetchProductDetail:fetchProductDetailUpdated
                                                  });
                                                } else {                                                  
                                                  this.setState({ 
                                                    documentTypeCheckForAdmission: false,
                                                    documentSizeCheckForAdmission: true,
                                                  });
                                                }
                                              }}
                                            />
                                          </span>
                                          <h4>Add Admission File</h4>

                                          {values.documentSizeCheckForAdmission ? (
                                            <p style={{ color: "red" }}>
                                              File Size is too large(Maximum File Size:200 KB).
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          {values.documentTypeCheckForAdmission ? (
                                            <p style={{ color: "red" }}>
                                              Invalid Format
                                            </p>
                                          ) : (
                                            ""
                                          )}
                                          <div className="col-md-12 col-sm-12">
                                            <span className="file-size-limit">
                                              Supported Formats: .pdf only. <br />
                                              File Size: Max 200 KB
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      </div>
        }
                                    </div>
                                    )}

                                  <div className="row">
                                    <div className="col-md-4 col-sm-6">
                                      <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                          rows="8"
                                          cols="50"
                                          maxLength={255}
                                          name="productDescription"
                                          id="productDescription"
                                          value={values.productDescription}
                                          onChange={handleChange}
                                          onBlur={(event) => {
                                            this.setState({
                                              productDescription:event.target.value
                                            });
                                          }}
                                          autoComplete="productDescription"
                                          className={
                                            "form-control" +
                                            (errors.productDescription &&
                                            touched.productDescription
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="productDescription"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                      <div className="form-group">
                                        <label>Video URL</label>
                                        <textarea
                                          rows="8"
                                          cols="50"
                                          maxLength={255}
                                          name="productVideourl"
                                          id="productVideourl"
                                          value={values.productVideourl}
                                          onChange={handleChange}
                                          onBlur={(event) => {
                                            let fetchProductDetailUpdated=fetchProductDetail;
                                            fetchProductDetailUpdated.productVideourl=event.target.value;                                            
                                            this.setState({
                                              fetchProductDetail:fetchProductDetailUpdated
                                            });
                                          }}
                                          autoComplete="productVideourl"
                                          className={
                                            "form-control" +
                                            (errors.productVideourl &&
                                            touched.productVideourl
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="productVideourl"
                                          className="validation"
                                          component="div"
                                        />
                                      </div>
                                    </div>
                                   
                                    {[10502, "10502"].includes(values.productType) && (
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                    <label>Level{" "}
                                        <span className="validation"> *</span> </label>
                                    <Field
                                      as="select"
                                      name="level"
                                      id="level"
                                      onChange={handleChange}
                                      onBlur={(event) => {
                                        let fetchProductDetailUpdated=fetchProductDetail;
                                        fetchProductDetailUpdated.levelID=event.target.value;                                            
                                        this.setState({
                                          fetchProductDetail:fetchProductDetailUpdated
                                        });
                                      }}
                                      title={values.level}
                                      className={
                                        "form-control" +
                                        (errors.level &&
                                        touched.level
                                          ? " is-invalid"
                                          : "")
                                      }
                                    >
                                      <>
                                        <option value={""}>-- Select --</option>
                                        {(this.state.productLevel || []).map(
                                          (level) => (
                                            <option
                                              key={level.levelID}
                                              value={level.levelID}
                                            >
                                              {level.levelName}
                                            </option>
                                          )
                                        )}
                                      </>
                                    </Field>
                                    <ErrorMessage
                                      name="level"
                                      className="validation"
                                      component="div"
                                    />
                                    </div>
                                  )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          {([10502,"10502"].includes(values.productType) && [2,"2"].includes(values.courseTypeID)) && (
                            <OpsEditQuestion
                            {...this.props}
                            parentCallback={this.handleCallback}
                            questionnaireDataProp={this.state.questionnaireData}
                          />
                          )}
                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                            <button
                              type="submit"
                              name="submitForm"
                              id="UpdateCourseSubmit"
                              className="btn-4 pull-right"
                              style={{ opacity: this.state.submitBtnClick ? 0.5 : 1 ,cursor: this.state.submitBtnClick ? "not-allowed" : "pointer" }}
                              disabled={this.state.submitBtnClick}
                              onClick={async () => {
                                const curErrors =
                                  await formikProps.validateForm();
                                const curErrorsKeys = Object.keys(curErrors);

                                if (curErrorsKeys.length) {
                                  // Assuming curErrorsKeys[0] identifies the first failing field, use that to
                                  // find the correct DOM element to call .focus() on.
                                  //
                                  // Since I set the id attribute on all my form's <input>s to match the error
                                  // keys, I just use document.getElementById(), but of course you could use refs
                                  const el = document.getElementById(
                                    curErrorsKeys[0]
                                  );

                                  if (el) 
                                  {
                                    this.scrollToSection(el);
                                    el.focus();
                                    setFieldTouched(curErrorsKeys[0], true);
                                  }  
                                }
                              }}
                            >
                              Update
                            </button>

                            <a href>
                              <button
                                type="button"
                                name="cancelForm"
                                className="btn-4 mr-20 pull-right"
                                onClick={this.handleCancel}
                              >
                                Cancel
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </section>
          </React.Fragment>
        )}
      />
       {/* Confirmation Pop Up Starts */}
       <div
              className="modal fade"
              id="myConfirmModalPrice"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              data-keyboard="false"
              data-backdrop="static"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                  </div>
                  <div style={{marginLeft:"5px"}} className="modal-body">
                   <p>
                {
                  "Add-on course has a higher price. Do you want to continue ?"        
                 }
      </p>
                  
                  </div>
                  <div className="modal-footer">
                
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateYes("price")}}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateNo("price")}}
                    >
                      No
                    </button>
                  
                  </div>
                </div>
              </div>
       
        </div>
         <div
              className="modal fade"
              id="myConfirmModalStatus"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              data-keyboard="false"
              data-backdrop="static"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                  </div>
                  <div style={{marginLeft:"5px"}} className="modal-body">
                   <p>
                {
               `${this.state.TypeText}, Do you want to continue ?`           
                }
      </p>
                  
                  </div>
                  <div className="modal-footer">
                
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateYes("status")}}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateNo("status")}}
                    >
                      No
                    </button>
                  
                  </div>
                </div>
              </div>
       
        </div>
         <div
              className="modal fade"
              id="myConfirmModalParent"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              data-keyboard="false"
              data-backdrop="static"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                  </div>
                  <div style={{marginLeft:"5px"}} className="modal-body">
                   <p>
                {"You have entered more price than parent course, Do you want to continue ?"}
      </p>
                  
                  </div>
                  <div className="modal-footer">
                
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateYes("parent")}}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="btn discount-table-heading"
                      data-dismiss="modal"
                      style={{
                        float: "right",
                        marginRight:"5px"
                      }}
                      onClick={()=>{this.removeStateNo("parent")}}
                    >
                      No
                    </button>
                  
                  </div>
                </div>
              </div>
       
        </div>
{/* Confirmation Pop Up Ends */}
</>
    );
  }
}

export default EditProduct;
